<template>
  <ms-dynamic-popup
    :maximum="true"
    :esc-to-close="escToClose"
    :title="titleVoucher"
    classTitle="ms-dynamic-popup-title"
    @beforeOpen="beforeOpen($event, close)"
    @beforeClose="beforeClose"
    classDetail="plan-adjustment-detail"
    @shortkeyAction="shortkeyAction"
    class="gl-general-voucher-detail"
  >
    <!-- icon -->
    <template v-slot:icon>
      <ms-button
        text="Hướng dẫn"
        type="icon-button"
        class="btn-guide gl-general-voucher-guide"
        leftIcon="ic-guide"
        @click="guide"
      />

      <ms-tour :steps="stepsDynamic" v-model:open="showStep" container=".gl-general-voucher-detail"></ms-tour>
      <ms-button
        text="Phím tắt"
            tooltipIconLeft="Phím tắt"
        type="icon-button"
        class="btn-guide gl-general-voucher-shortkey"
        leftIcon="ic-shortkey"
        @click="clickShortkeyBtn"
      />

      <div
        class="button icon24 setting-small mr-2"
        v-tooltip="'Tùy chỉnh giao diện'"
        shortkey-target="ConfigLayout"
        @click="clickSettingLayout"
      ></div>
      <div class="button icon24 email mr-2" v-tooltip="'Email'"></div>
      <a target="_blank" :href="linkHelp($ms.constant.Help.GLVoucher)">
        <div
          class="button icon24 ic-question mr-2 gl-general-voucher-question"
          v-tooltip="'Trợ giúp'"
          shortkey-target="Help"
        ></div>
      </a>
    </template>
    <!-- content -->
    <template v-slot:content>
      <div class="h-100 flex-column popup-container">
        <div class="amount-text">Tổng tiền</div>
        <div class="central-title">
          <div class="title-control-group" :class="{active: true}" @click="toggleAboveHandler">Thông tin chung</div>
          <div class="amount-total">
            <div class="amount-value">
              {{
                $ms.format.formatData(totalAmountComputed, {
                  formatType: $ms.constant.FormatType.Amount,
                })
              }}
            </div>
          </div>
        </div>
        <!-- Bên trên -->
        <div above-container v-show="toggleAbove">
          <div class="above-container flex-row">
            <!-- Bên trái -->
            <div class="above-left flex6">
              <div class="flex-row control-group mr-2">
                <div class="control-title" :class="{'control-title-small': this.dbOptions?.HeightOption == 1}">
                  <label>Diễn giải</label>
                </div>
                <div class="control-right">
                  <ms-textarea
                    :disabled="(viewing && !isQuickEditVoucher) || this.isFromCompareConvert"
                    :rows="6"
                    v-model="model.journal_memo"
                    :maxLength="255"
                    :class="dbOptionHeight"
                  />
                </div>
              </div>

              <div class="flex-row control-group mr-2" v-if="isShowVoucherReference">
                <div class="control-title" :class="{'control-title-small': this.dbOptions?.HeightOption == 1}">
                  <label title="Tham chiếu">Tham chiếu</label>
                </div>
                <div class="control-right align-item-center voucher-reference">
                  <div class="voucher-reference-item" v-if="voucherReferenceItems[0]?.ref_no">
                    <div class="ref-no d-flex">
                      <a class="text-link" @click="showTargetLink(voucherReferenceItems[0])">{{
                        voucherReferenceItems[0]?.ref_no
                      }}</a>
                      <label class="icon24 ic-remove" v-if="!viewing" @click="removeVoucherReference"></label>
                    </div>
                  </div>

                  <label class="text-link more-voucher-reference icon24" @click="showFormVoucherReference"></label>
                </div>
              </div>
            </div>
            <!-- Bên phải -->
            <div class="above-right">
              <div class="seperator-line" :class="dbOptionHeight"></div>
              <div class="flex-column">
                <div class="flex-row control-group ml-2">
                  <div class="control-title-right" :class="{'control-title-small': this.dbOptions?.HeightOption == 1}">
                    <label title="Ngày chứng từ">Ngày CT</label>
                  </div>
                  <div class="w-180px">
                    <ms-datepicker
                      class="flex2"
                      v-model="model.ref_date"
                      :tooltipIcon="'Chọn ngày tháng'"
                      :disabled="viewing || this.isFromCompareConvert"
                      :rules="[{name: $ms.constant.ValidateRule.Required}]"
                      @onBlurActionDatePicker="onBlurActionDatePicker(this)"
                      @msChangeData="validateRefDate"
                    />
                  </div>
                </div>
                <div class="flex-row control-group ml-2">
                  <div class="control-title-right" :class="{'control-title-small': this.dbOptions?.HeightOption == 1}">
                    <label title="Ngày hạch toán">Ngày HT</label>
                  </div>
                  <div class="w-180px">
                    <ms-datepicker
                      class="flex2"
                      v-model="model.posted_date"
                  :tooltipIcon="'Chọn ngày tháng'"
                      :disabled="viewing || this.isFromCompareConvert"
                      :rules="[{name: $ms.constant.ValidateRule.Required}]"
                    />
                  </div>
                </div>
                <div class="flex-row control-group ml-2">
                  <div class="control-title-right" :class="{'control-title-small': this.dbOptions?.HeightOption == 1}">
                    <label title="Số chứng từ">Số CT</label>
                  </div>
                  <div class="w-180px">
                    <ms-input
                      class="flex2"
                      v-model="model.ref_no"
                      :maxLength="20"
                      :rules="[{name: $ms.constant.ValidateRule.Required}]"
                      :disabled="viewing || this.isFromCompareConvert"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- Bên dưới -->
        <div class="flex1 under-container">
          <button
            class="toggle-above icon24"
            :class="{expand: toggleAbove}"
            :tabindex="-1"
            @click="toggleAboveHandler"
            v-if="!toggleAbove"
            v-tooltip="'Mở rộng'"
          ></button>
          <button
            class="toggle-above icon24"
            :class="{expand: toggleAbove}"
            :tabindex="-1"
            @click="toggleAboveHandler"
            v-if="toggleAbove"
            v-tooltip="'Thu nhỏ'"
          ></button>
          <ms-resize-screen isFlex class="flex-column flex">
            <template v-slot:content-master>
              <div class="toolbar-grid flex-between">
                <div class="content-left">
                  <div
                    class="item-tabs"
                    :class="{active: selectedTab == 0}"
                    @click="selectedTabHandler(0)"
                    :tabindex="-1"
                  >
                    Hạch toán
                  </div>
                  <div
                    class="item-tabs"
                    :class="{active: selectedTab == 1}"
                    @click="selectedTabHandler(1)"
                    :tabindex="-1"
                  >
                    Thống kê
                  </div>
                  <div
                    class="item-tabs"
                    :class="{active: selectedTab == 2}"
                    @click="selectedTabHandler(2)"
                    :tabindex="-1"
                    v-if="useTA"
                  >
                    Thuế
                  </div>
                </div>

                <div class="flex-row flex-center">
                  <ms-checkbox 
                    v-if="isTaxReduction && this.dbOptions?.TaxCalculationMethod == $ms.constant.TaxCalculationMethod.DirectMethod"
                    label="Giảm 20% thuế GTGT theo Nghị quyết giảm thuế" 
                    v-model="model.is_tax_reduction"
                    :disabled="viewing"
                    />
                  <label class="ml-2 label text-nowrap">Loại tiền</label>

                  <div class="ml-2 w100px">
                    <ms-combobox
                      :columns="currencyColumns"
                      valueField="currency_code"
                      displayField="currency_code"
                      ref="refCurrencyCode"
                      :data="comboboxDataRemote.currency"
                      v-model="model.currency_code"
                      :initText="model.currency_code"
                      @selected="selectCurrency"
                      :dropdownWidth="600"
                      :class="['input-editor', 'currency-combo']"
                      :queryMode="'remote'"
                      :remoteFilter="true"
                      @comboboxLoadData="onCurrencyComboboxLoadData"
                      :disabled="viewing || this.isFromCompareConvert"
                      @blur="assignValueCurrency"
                    ></ms-combobox>
                  </div>
                  <label
                    class="text-nowrap ml-2"
                    v-show="model.currency_code != $t('i18nEnum.Currency.VND') && model.currency_code"
                    >Tỷ giá</label
                  >
                  <div
                    class="ml-2 w100px"
                    v-show="model.currency_code != $t('i18nEnum.Currency.VND') && model.currency_code"
                  >
                    <ms-number
                      v-model="model.exchange_rate"
                      :disabled="viewing"
                      @onActionBlur="onActionBlur"
                      :formatType="$ms.constant.FormatType.ExchangeRate"
                      :max="999999"
                    ></ms-number>
                  </div>
                  <ms-button
                    :disabled="viewing || !isViewInvoce || this.isFromCompareConvert"
                    text="Xem công nợ phải trả"
                    class="ml-2"
                    :hasBorder="true"
                    @click="showRefNoInvoice"
                    type="outline-button circle-button btn-multi-action-detail"
                  />
                  <menu-wrapper class="topnav-widget-more-container ml-2" :maxHeight="200">
                    <template #menu-button="{toggleMenu}">
                      <ms-button
                        :disabled="viewing || this.isFromCompareConvert"
                        text="Định khoản nhanh"
                        :hasBorder="true"
                        type="outline-button circle-button btn-multi-action-detail"
                        @click="toggleMenu"
                        rightIcon="down-arrow-black"
                    /></template>
                    <template #menu-content>
                      <menu-item
                        v-for="(item, index) in accountingActions"
                        :key="index"
                        :seperatorBottom="item.seperatorBottom"
                        @click="clickQuickAccounting(item.id)"
                        >{{ item.text }}</menu-item
                      ></template
                    >
                  </menu-wrapper>
                </div>
              </div>
              <div class="flex d-flex" v-show="selectedTab < 2">
                <ms-grid-editor
                  :data="model.GLVoucherDetails"
                  ref="refDetail"
                  formId="plan-adjustment-detail"
                  class="flex-box"
                  v-model:list="model.GLVoucherDetails"
                  idField="ref_detail_id"
                  greyTitle
                  :propsData="propsData"
                  :footer="true"
                  :disabled="viewing"
                  @updateBusiness="changeDataBusiness"
                  @resizeStop="onResizeStop"
                  @copyDownRow="copyDownRow"
                  @copyActionClick="copyActionClick"
                  isCopyDataColumn
                  :changeTriggers="changeTriggers"
                  @onEditEventCellEditor="
                    (colIndex, rowIndex, $grid) => {
                      toggleAboveHandlerGrid(colIndex, rowIndex, $grid, this);
                    }
                  "
                  @initDataBeforeAddRow="
                    (rowBack, rowIndex, $grid) => {
                      toggleAboveHandlerGrid(null, rowIndex, $grid, this);
                    }
                  "
                  :lineBreak="this.dbOptions?.LineBreak ?? 1"
                  :configVoucherQuickEdit="configAccountingGrid"
                  :isQuickEditVoucher="isQuickEditVoucher"
                  :itemRightClicks="itemRightClicks"
                  @afterRightClickAction="viewAccount(this)"
                ></ms-grid-editor>
              </div>
              <div class="flex d-flex" v-show="selectedTab == 2">
                <ms-grid-editor
                  formId="plan-adjustment-detail"
                  :data="model.GLVoucherDetailTaxs"
                  ref="refDetailOther"
                  class="flex-box"
                  v-model:list="model.GLVoucherDetailTaxs"
                  idField="ref_detail_id"
                  greyTitle
                  :propsData="propsData"
                  :footer="true"
                  :disabled="viewing"
                  @updateBusiness="changeDataBusiness"
                  @resizeStop="onResizeStop"
                  @copyDownRow="copyDownRow"
                  @copyActionClick="copyActionClick"
                  isCopyDataColumn
                  :changeTriggers="changeTriggersTax"
                  @onEditEventCellEditor="
                    (colIndex, rowIndex, $grid) => {
                      toggleAboveHandlerGrid(colIndex, rowIndex, $grid, this);
                    }
                  "
                  @initDataBeforeAddRow="
                    (rowBack, rowIndex, $grid) => {
                      toggleAboveHandlerGrid(null, rowIndex, $grid, this);
                    }
                  "
                  :configVoucherQuickEdit="configTaxGrid"
                  :isQuickEditVoucher="isQuickEditVoucher"
                  :itemRightClicks="itemRightClicks"
                  @afterRightClickAction="viewAccount(this)"
                ></ms-grid-editor>
              </div>
            </template>
            <template v-slot:content-item>
              <div class="flex-column flex">
                <div class="toolbar-grid flex-between">
                  <div class="content-left">
                    <div class="item-tabs active">Hạch toán đồng thời</div>
                  </div>

                  <div class="flex-row flex-center">
                    <ms-button
                      type="secondary-outline"
                      leftIcon="update-down"
                      text="Cập nhật hạch toán đồng thời"
                      @click="generateParallel(true)"
                      :disabled="viewing || this.isFromCompareConvert"
                      class="update-btn"
                    />
                  </div>
                </div>
                <div class="flex d-flex">
                  <ms-grid-editor
                    formId="plan-adjustment-detail"
                    :disabled="viewing || this.isFromCompareConvert"
                    :data="model.Parallels"
                    v-model:list="model.Parallels"
                    ref="refDetailParallel"
                    class="flex-box"
                    idField="ref_detail_id"
                    greyTitle
                    :columns="columnsDataParalell"
                    :propsData="propsDataParalell"
                    :footer="true"
                    @updateBusiness="changeDataBusiness"
                    @copyDownRow="copyDownRow"
                    @copyActionClick="copyActionClick"
                    isCopyDataColumn
                    :changeTriggers="changeTriggersHT"
                    @afterDeleteRow="afterDeleteRow"
                    @onEditEventCellEditor="
                      (colIndex, rowIndex, $grid) => {
                        toggleAboveHandlerGrid(colIndex, rowIndex, $grid, this);
                      }
                    "
                    :name="'gridParallel'"
                    :configVoucherQuickEdit="configParallelGrid"
                    :isQuickEditVoucher="isQuickEditVoucher"
                    :itemRightClicks="itemRightClicks"
                    @afterRightClickAction="viewAccount(this)"
                  ></ms-grid-editor>
                </div>
              </div>
            </template>
          </ms-resize-screen>
        </div>
      </div>
    </template>
    <!-- footer -->
    <template v-slot:footer="{}">
      <div class="h-100 flex-between flex1" style="flex-direction: row-reverse">
        <div class="flex-row" v-if="viewing">
          <ms-button
            text="Sửa"
            class="mr-2 step-8-unposted"
            type="btn-custom"
            v-tooltip="'Sửa (Ctrl + E)'"
            shortkey-target="Edit"
            v-if="this.isShowEditAndPosted"
            @click="clickEdit"
            :disabled="offlineReady"
          ></ms-button>
          <ms-button
            text="Ghi sổ"
            v-if="this.isShowEditAndPosted"
            class="step-close"
            shortkey-target="Posted"
            @click="commandClick($ms.constant.Command.Posted)"
            :disabled="offlineReady"
          ></ms-button>
          <!-- start - button cho Sửa nhanh chứng từ -->
          <div class="flex-row" v-if="this.isShowUnPosted && isQuickEditVoucher" style="flex-direction: row-reverse">
            <ms-button
              text="Cất"
              v-tooltip="'Cất (Ctrl + S)'"
              class="step-close"
              shortkey-target="Save"
              @click="commandClick($ms.constant.Command.SaveView)"
            ></ms-button>
            <ms-button
              text="Hoãn"
              type="btn-custom"
              class="mr-footer-btn"
              v-tooltip="'Hoãn (Ctrl + U)'"
              shortkey-target="Postpone"
              @click="commandClick($ms.constant.Command.Postpone)"
            ></ms-button>
          </div>
          <ms-button
            text="Sửa nhanh"
            title="Sửa nhanh"
            class="mr-footer-btn step-7-posted"
            type="btn-custom"
            v-if="this.isShowUnPosted && !isQuickEditVoucher"
            shortkey-target="QuickEdit"
            @click="eventQuickEditVoucher"
          ></ms-button>
          <!-- end -->
          <ms-button
            text="Bỏ ghi"
            v-if="this.isShowUnPosted && !isQuickEditVoucher"
            class="step-close"
            shortkey-target="UnPosted"
            @click="commandClick($ms.constant.Command.UnPosted)"
          ></ms-button>
        </div>
        <div class="flex-row" v-if="!viewing" style="flex-direction: row-reverse">
          <ms-button
            text="Cất"
            v-tooltip="'Cất (Ctrl + S)'"
            shortkey-target="Save"
            class="step-close"
            @click="commandClick($ms.constant.Command.SaveView)"
            v-if="this.editMode != this.$ms.constant.FormState.View"
          ></ms-button>
          <ms-button
            text="Hoãn"
            v-tooltip="'Hoãn (Ctrl + U)'"
            shortkey-target="Postpone"
            type="btn-custom"
            class="mr-2"
            @click="commandClick($ms.constant.Command.Postpone)"
            v-if="!viewing"
          ></ms-button>
        </div>
        <div class="flex-row flex-center" v-if="!this.isFromCompareConvert">
          <ms-button
            leftIcon="refresh-white-big"
            type="btn-footer-helpful"
            text="Nạp"
            v-tooltip="'Nạp (Ctrl + R)'"
            @click="refresh"
            :disabled="this.editMode != this.$ms.constant.FormState.View"
            class="btn-opacity max-height pl-1"
            v-show="this.isShowRefreshAndApprove"
          ></ms-button>
          <div class="seperator-button" v-show="this.isShowRefreshAndApprove"></div>

          <ms-drop-down-button
            leftIcon="utilities-white-big"
            type="secondary-outline"
            text="Tiện ích"
            class="max-height step-5-pos"
            classCustom="btn-opacity"
            :menuItems="buttonUtilities"
            isBtnFooterHelpFul
            @menuClick="clickItemHandle"
            :byDateClose="!this.isShowRefreshAndApprove"
          ></ms-drop-down-button>
          <div class="seperator-button"></div>
          <!-- @menuClick="itemCLick" lúc đầu nó là thế này nhưng chưa thấy có gì -->
          <ms-drop-down-button
            leftIcon="print-white-big"
            type="secondary-outline"
            text="In"
            :isBtnPrint="true"
            @printPreviousReport="printPreviousReport"
            class="max-height step-6-pos"
            classCustom="btn-opacity"
            isBtnFooterHelpFul
            :menuItems="printMenu"
            @menuClick="printItemCLick"
            :maxHeight="$t('i18nNumber.maxPrintHeight')"
            :disabled="!viewing"
          ></ms-drop-down-button>

          <div class="seperator-button" v-show="this.isShowRefreshAndApprove"></div>

          <ms-button
            leftIcon="approve-white-big"
            type="btn-footer-helpful"
            text="Duyệt"
            shortkey-target="Approve"
            :disabled="!viewing || isShowFromReport || stateApprove"
            @click="onApproveAction"
            class="btn-opacity max-height"
            v-show="this.isShowRefreshAndApprove"
          ></ms-button>
          <div class="seperator-button"></div>

          <ms-button
            leftIcon="ic-delete-voucher"
            type="btn-footer-helpful"
            text="Xóa"
            shortkey-target="Delete"
            class="btn-opacity max-height step-7-unposted"
            v-tooltip="'Xóa (Ctrl + D)'"
            :disabled="disabledDelete"
            @click="clickItemHandle({command: $ms.constant.Command.Delete})"
          ></ms-button>
          <button
            shortkey-target="Add"
            @click="clickItemHandle({command: 'Voucher'})"
            class="d-none"
            v-if="viewing"
          ></button>
          <button
            shortkey-target="Duplicate"
            @click="clickItemHandle({command: $ms.constant.Command.Duplicate})"
            class="d-none"
            v-if="viewing"
          ></button>
          <button
            shortkey-target="CopyVoucher"
            @click="clickItemHandle({command: $ms.constant.Command.Copy})"
            class="d-none"
            v-if="!viewing"
          ></button>
          <button
            shortkey-target="ViewAccount"
            @click="clickItemHandle({command: $ms.constant.Command.ViewAccount})"
            class="d-none"
          ></button>
          <button
            shortkey-target="Delete"
            @click="clickItemHandle({command: $ms.constant.Command.Delete})"
            class="d-none"
            v-if="viewing && !model.is_posted && this.isShowRefreshAndApprove"
          ></button>
        </div>
        <div class="flex-row">
          <ms-button
            type="btn-custom"
            v-if="viewing && this.isShowRefreshAndApprove && !this.isFromCompareConvert"
            leftIcon="left-arrow-white"
            class="mr-1"
            shortkey-target="ArrowLeft"
            :disabled="!currentIndexBack"
            v-tooltip="'Trước'"
            @click="commandClick($ms.constant.Command.BackVoucher)"
          ></ms-button>
          <ms-button
            type="btn-custom"
            v-if="viewing && this.isShowRefreshAndApprove && !this.isFromCompareConvert"
            shortkey-target="ArrowRight"
            leftIcon="right-arrow-white"
            :disabled="!currentIndexNext"
            v-tooltip="'Sau'"
            @click="commandClick($ms.constant.Command.NextVoucher)"
            class="mr-1"
          ></ms-button>
          <ms-button
            text="Đóng"
            type="btn-custom"
            class="mr-2"
            @click="hide()"
            v-tooltip="'Đóng (Ctrl + Q)'"
            shortkey-target="Quit"
          ></ms-button>
        </div>
      </div>
      <div v-if="!viewing">
        <button
          class="d-none"
          :shortkey-target="$ms.constant.Command.InsertRowGrid"
          @click="commandClick($ms.constant.Command.InsertRowGrid)"
        ></button>
        <button
          class="d-none"
          :shortkey-target="$ms.constant.Command.DeleteRowGrid"
          @click="commandClick($ms.constant.Command.DeleteRowGrid)"
        ></button>
      </div>
    </template>
  </ms-dynamic-popup>
</template>
<script>
import msDynamicPopup from '@/components/popup/MsDynamicPopup.vue';
import msGridEditor from '@/components/gridEditor/MsGridEditor.vue';
import baseDetailVoucher from '@/views/base/baseDetailVoucher';
import baseDetail from '@/views/base/baseDetail';
import MenuWrapper from '@/components/dropdown/MenuWrapper.vue';
import MenuItem from '@/components/dropdown/MenuItem.vue';
import {reactive, ref, getCurrentInstance, onMounted, computed, shallowRef} from 'vue';
import {ModuleGLVoucher} from '@/stores/moduleConst';
import {useGLVoucherDetailData} from './GLVoucherDetailData.js';
import {useComboboxColumns} from '@/commons/combobox/comboboxColumns';
import {useCurrencyCombo} from '@/commons/combobox/CurrencyCombo.js';
import {useCurrencyShowColumn} from '@/commons/gridColumn/CurrencyShowColumn.js';
import {useActionGridEditor} from '@/commons/gridColumn/ActionGridEditor.js';
import {useQuickAccountingVoucher} from '@/setup/utilities/quickAccountingVoucher.js';
import RefType from '@/commons/wildcards/constants/RefType.js';
import {useInforCommons} from '../../utility/commons/inforCommons.js';
import {useActionParallel} from '@/commons/gridColumn/ActionParallel.js';
import popupUtil from '@/commons/popupUtil';
import GLVoucherAPI from '@/apis/gl/gLVoucherAPI.js';
import {showError, showConfirm, showConfirmValidate} from '@/commons/globalMessage';
import {ModuleContext} from '@/stores/moduleConst';
import {mapGetters} from 'vuex';
import commonFn from '@/commons/commonFunction.js';
import sASaleInvoiceAPI from '@/apis/sa/sASaleInvoiceAPI.js';
import {useCAReceiptSaleDetailData} from '@/views/sell/cAReceiptSale/CAReceiptSaleDetailData.js';
import {useCacheAccountComboConfig} from '@/commons/combobox/cacheCombo/cacheAccountComboConfig.js';
import {useCacheBudgetSourceComboConfig} from '@/commons/combobox/cacheCombo/cacheBudgetSourceComboConfig.js';
import {useCacheBudgetChapterComboConfig} from '@/commons/combobox/cacheCombo/cacheBudgetChapterComboConfig.js';
import {useCacheBudgetKindItemComboConfig} from '@/commons/combobox/cacheCombo/cacheBudgetKindItemComboConfig.js';
import {useCacheBudgetItemComboConfig} from '@/commons/combobox/cacheCombo/cacheBudgetItemComboConfig.js';
import {useCacheProjectComboConfig} from '@/commons/combobox/cacheCombo/cacheProjectComboConfig.js';
import {useCacheAccountingObjectComboConfig} from '@/commons/combobox/cacheCombo/cacheAccountingObjectComboConfig.js';
import {useCacheActivityComboConfig} from '@/commons/combobox/cacheCombo/cacheActivityComboConfig.js';
import {useCacheStatisticComboConfig} from '@/commons/combobox/cacheCombo/cacheStatisticComboConfig.js';
import {useCacheBankInfoComboConfig} from '@/commons/combobox/cacheCombo/cacheBankInfoComboConfig.js';
import {useCacheContractComboConfig} from '@/commons/combobox/cacheCombo/cacheContractComboConfig.js';
import {useCacheTopicComboConfig} from '@/commons/combobox/cacheCombo/cacheTopicComboConfig.js';
import {useCacheTaskComboConfig} from '@/commons/combobox/cacheCombo/cacheTaskComboConfig.js';
import {useCacheBudgetProvideComboConfig} from '@/commons/combobox/cacheCombo/cacheBudgetProvideComboConfig.js';
import {useCacheFundStructureComboConfig} from '@/commons/combobox/cacheCombo/cacheFundStructureComboConfig.js';
import {useCacheFundComboConfig} from '@/commons/combobox/cacheCombo/cacheFundComboConfig.js';
import {useCacheBudgetFeesComboConfig} from '@/commons/combobox/cacheCombo/cacheBudgetFeesComboConfig.js';
import {useCachePurchasePurposeComboConfig} from '@/commons/combobox/cacheCombo/cachePurchasePurposeComboConfig.js';
import {useCacheStockComboConfig} from '@/commons/combobox/cacheCombo/cacheStockComboConfig.js';
import {useCacheInvoiceFormNumberComboConfig} from '@/commons/combobox/cacheCombo/cacheInvoiceFormNumberComboConfig.js';
import MsTour from '@/components/tour/MsTour.vue';
import {useSelectRefNoInvoice} from '@/views/common/selectRefNoInvoice.js';
import {useCopyNewVoucher} from '@/views/utility/commons/copyNewVoucher.js';
import sAReceiptAPI from '@/apis/sa/sAReceiptAPI.js';
import sAElectronicTicketAPI from '@/apis/sa/sAElectronicTicketAPI.js';
import {useValidateBudgetSourceAccount} from '@/views/utility/commons/validateBudgetSourceAccount.js';
import msResizeScreen from '@/components/resize-wrapper/MsResizeScreen.vue';
import _ from 'lodash';
import {ModuleOfflineWork} from '@/stores/moduleConst';
import accountAPI from '@/apis/di/accountAPI.js';
import {collectionMonitor} from '@/setup/utilities/monitor';

export default {
  components: {
    msDynamicPopup,
    msGridEditor,
    MenuWrapper,
    MenuItem,
    MsTour,
    msResizeScreen,
  },
  extends: baseDetailVoucher,
  name: 'GLGeneralVoucherDetail',
  setup() {
    const titleCode = 'detail_popup_glgeneralvoucherdetail';
    const {proxy} = getCurrentInstance();
    const module = ModuleGLVoucher;
    let layoutTagDetail = ref('GLVoucherDetailHT');
    let layoutTagDetailOther = ref('GLVoucherDetailTax');
    let layoutTagDetailParallel = ref('Parallels');
    const currentLayout = ref('GLVoucherDetailHT');
    const isCacheParam = ref(true);
    // có hiển thị checkbox giảm 20% thuế GTGT
    const isTaxReduction = ref(true);
    const subSystemCode = proxy.$ms.constant.SubSystemCode.GLVoucher;
    const dbOptionHeight = computed(() => {
      return 'text-area-height' + parseInt(proxy.$store?.state?.dbOption?.dbOptions.HeightOption || 2);
    });

     //HMDuc2: Biến đánh dấu tính thuế theo PP nào
    const isDirectMethodTax = ref(false);
    const taxDirectMethodValue = [0, 1, 2, 3, 5];
    const cloneVoucherDetail = ref([]);

    // NHCUONG 23.06.2023: Các thông tin cho chứng từ tham chiếu
    const voucherReferenceItems = ref([]);
    const isAcceptValidateVoucherReference = ref(false);
    const refTypeAcceptVoucherReference = ref([
      proxy.$ms.constant.RefType.CAReceiptPlanWithdraw,
      proxy.$ms.constant.RefType.CAPayment,
      proxy.$ms.constant.RefType.CAPaymentPurchase,
      proxy.$ms.constant.RefType.CAPaymentFixedAsset,
      proxy.$ms.constant.RefType.CAPaymentVendor,
      proxy.$ms.constant.RefType.BAWithDraw,
      proxy.$ms.constant.RefType.BAWithdrawPurchase,
      proxy.$ms.constant.RefType.BAWithDrawFixedAsset,
      proxy.$ms.constant.RefType.BAWithdrawVendor,
      proxy.$ms.constant.RefType.GLGeneralVoucher,
      proxy.$ms.constant.RefType.BUTransferDeposit,
    ]);
    // có sử dụng nghiệp vụ thuế hay không
    const useTA = ref(false);

    /**
     * Cấu hình ref grid để base đọc
     */
    onMounted(() => {
      // Load thêm layout tab Thuế nếu sinh từ Vé điện tử
      if (proxy._formParam && proxy._formParam.isTicketGenerateData) {
        layoutTagDetailOther.value = 'GLVoucherDetailTax';
      }
      proxy.$store.dispatch('dbOption/getDbOptions').then(x => {
        isDirectMethodTax.value = x.TaxCalculationMethod === 1;
      });
    });

    proxy._gridDetails = {
      GLVoucherDetails: 'refDetail',
      GLVoucherDetailTaxs: ' refDetailOther',
      Parallels: 'refDetailParallel',
    };
    proxy._defaultRow = 3;

    /**
     * Config sửa nhanh chứng từ
     */
    const configAccountingGrid = [
      'description', // diễn giải
      'contract_no', //hợp đồng
      'activity_name', // hoạt động
      'statistic_code', // mã thống kê
      'topic_code', //đề tài
      'task_code', //nhiệm vụ
      'is_source_before_year', // nguồn năm trước
      'fund_structure_name', //cơ cấu vốn
      'project_activity_id', //hoạt động dự án
      'project_expense_id', //khoản chi dự án
      'project_expense_code',
    ];

    const configTaxGrid = ['description', 'accounting_object_name', 'accounting_object_address', 'company_tax_code'];

    const configParallelGrid = ['description'];

    /**
     * Chọn tab active
     * NNLINH 24.05.2022
     */
    const selectedTab = ref(0);
    const {showRefNoInvoice, isViewInvoce} = useSelectRefNoInvoice();

    /**
     * Lưu lại ref_no trước khi update phục vụ cập nhật lại refno_finance màn hình InvoiceBot_List
     * HMDUC2 02/01/2023
     */
    const refNoBeforeUpdate = ref(''); 

    /**
     * Cấu hình file DATA
     */
    const {
      toggleAbove,
      toggleAboveHandler,
      comboboxDataRemote,
      comboboxLoadData,
      columnParallel,
      accountComboMostDetailConfig,
      budgetSourceComboConfig, //Nguồn
      budgetProvideComboConfig,
      budgetDetailItemComboConfig,
      budgetKindItemComboConfig,
      TaskComboConfig,
      accountingObjectComboConfig,
      accountingObjectComboCreditConfig,
      accountingObjectComboDebitConfig,
      purchasePurposeComboConfig,
      budgetChapterComboConfig, // Chương
      budgetSubKindItemComboConfig, //Khoản
      budgetItemComboConfig, //Mục
      budgetSubItemComboConfig, //Tiểu mục
      activityComboConfig, // hoạt động
      statisticComboConfig, //thống kê
      projectComboConfig,
      bankAccountComboConfig,
      budgetFeesComboConfig,
      topicComboConfig,
      fundStructureComboConfig,
      contractComboConfig,
      buttonUtilities,
      buttonPrints,
      formatPrice,
      copyDownRowExtend,
      projectExpenseComboConfig,
    } = useGLVoucherDetailData();

    const {viewAccount, onBlurActionDatePicker} = useInforCommons();

    const selectedTabHandler = async value => {
      // Đoạn này chuyển tab thì sumbit trước tránh trường hợp không gán đc dc dữ liệu
      await proxy.gridDetail.submitEditor();
      switch (value) {
        case 0:
          layoutTagDetail.value = 'GLVoucherDetailHT';
          currentLayout.value = 'GLVoucherDetailHT';
          break;
        case 1:
          layoutTagDetail.value = 'GLVoucherDetailSta';
          currentLayout.value = 'GLVoucherDetailSta';
          break;
        case 2:
          layoutTagDetailOther.value = 'GLVoucherDetailTax';
          currentLayout.value = 'GLVoucherDetailTax';
          // init layout tránh bị lệch cột tiền
          proxy.initLayoutDetailOther();
          break;
      }
      selectedTab.value = value;
    };
    const {
      cacheAccountDebitCombo,
      cacheAccountCreditCombo,
      cacheAccountTaxCreditCombo,
      cacheAccountMostDetailCombo,
      cacheAccountDebitParalellCombo,
      cacheAccountCreditParalellCombo,
    } = useCacheAccountComboConfig();
    cacheAccountDebitCombo.modelValueField = 'debit_account';
    cacheAccountCreditCombo.modelValueField = 'credit_account';
    cacheAccountTaxCreditCombo.modelValueField = 'tax_account';
    cacheAccountDebitParalellCombo.modelValueField = 'debit_account';
    cacheAccountCreditParalellCombo.modelValueField = 'credit_account';
    const {cacheBudgetSourceComboConfig} = useCacheBudgetSourceComboConfig();
    const {cacheBudgetChapterComboConfig} = useCacheBudgetChapterComboConfig();
    const {cacheBudgetKindItemComboConfig, cacheBudgetSubKindItemComboConfig} = useCacheBudgetKindItemComboConfig();
    const {cacheBudgetItemComboConfig, cacheBudgetSubItemComboConfig, cacheBudgetDetailItemComboConfig} =
      useCacheBudgetItemComboConfig();
    const {cacheProjectComboConfig} = useCacheProjectComboConfig();
    const {cacheActivityComboConfig} = useCacheActivityComboConfig();
    const {cacheStatisticComboConfig} = useCacheStatisticComboConfig();
    const {cacheBankInfoComboConfig} = useCacheBankInfoComboConfig();
    const {cacheContractComboConfig} = useCacheContractComboConfig();
    const {cacheTopicComboConfig} = useCacheTopicComboConfig();
    const {cacheTaskComboConfig} = useCacheTaskComboConfig();
    const {cacheBudgetProvideComboConfig} = useCacheBudgetProvideComboConfig();
    const {cacheFundStructureComboConfig} = useCacheFundStructureComboConfig();
    const {cacheFundComboConfig} = useCacheFundComboConfig();
    const {cacheBudgetFeesComboConfig} = useCacheBudgetFeesComboConfig();
    const {cachePurchasePurposeComboConfig} = useCachePurchasePurposeComboConfig();
    const {cacheStockComboConfig} = useCacheStockComboConfig();
    const {cacheInvoiceFormNumberComboConfig} = useCacheInvoiceFormNumberComboConfig();

    /**
     *Cấu hình các field của grid
     */
    const propsData = {
      debit_account: cacheAccountDebitCombo,
      credit_account: cacheAccountCreditCombo,
      budget_provide_code: cacheBudgetProvideComboConfig,
      budget_source_name: cacheBudgetSourceComboConfig,
      budget_chapter_code: cacheBudgetChapterComboConfig,
      budget_item_code: cacheBudgetItemComboConfig,
      budget_detail_item_code: cacheBudgetDetailItemComboConfig,
      budget_sub_item_code: cacheBudgetSubItemComboConfig,
      budget_kind_item_code: cacheBudgetKindItemComboConfig,
      budget_sub_kind_item_code: cacheBudgetSubKindItemComboConfig,
      debit_accounting_object_code: accountingObjectComboDebitConfig,
      credit_accounting_object_code: accountingObjectComboCreditConfig,
      accounting_object_code: accountingObjectComboConfig,
      activity_name: cacheActivityComboConfig,
      statistic_code: cacheStatisticComboConfig,
      project_code: cacheProjectComboConfig,
      bank_account: cacheBankInfoComboConfig,
      task_code: cacheTaskComboConfig,
      fund_structure_name: cacheFundStructureComboConfig,
      method_distribute_name: {
        enum: 'MethodDistributeType',
        modelValueField: 'method_distribute_type',
      },
      cash_withdraw_type_name: {
        enum: 'CashWithDrawType',
        modelValueField: 'cash_withdraw_type_id',
      },
      tax_rate: {
        enum: 'TaxRateInventory',
        modelValueField: 'tax_rate',
      },
      industry_group_rate: {
        enum: 'TaxCalculationOccupation',
        modelValueField: 'industry_group_rate',
      },
      inv_type: {
        enum: 'InvType',
        modelValueField: 'inv_type',
      },
      budget_fees_code: cacheBudgetFeesComboConfig,
      topic_code: cacheTopicComboConfig,

      contract_no: cacheContractComboConfig,
      purchase_purpose_code: cachePurchasePurposeComboConfig,
      amount: {
        max: proxy.$ms.constant.RangeOfNumber.MaxAmount,
      },
      inv_type_code: {
        maxLength: 25,
      },
      turn_over: {
        maxLength: 18,
      },
      amount_oc: {
        maxLength: 14,
      },
      org_ref_no: {
        maxLength: 20,
      },
      inv_no: {
        maxLength: 20,
      },
      description: {
        maxLength: 255,
      },
      quantity: {
        min: 0,
        maxLength: 18,
      },
      norm: {
        maxLength: 18,
      },
      unitprice: {
        maxLength: 18,
      },
      debit_accounting_object_name: {
        maxLength: 255,
      },
      redit_accounting_object_name: {
        maxLength: 255,
      },
      project_expense_code: projectExpenseComboConfig,
      rowAction: ['Insert', 'Delete'],
    };
    // config grid hạch toán đồng thời
    var propsDataParalell = Object.assign({}, propsData);
    propsDataParalell.debit_account = cacheAccountDebitParalellCombo;
    propsDataParalell.credit_account = cacheAccountCreditParalellCombo;
    //#region Xử lý quy đổi tiền
    const {currencyColumns} = useComboboxColumns();
    const {columnsDataParalell} = useCurrencyShowColumn(proxy, columnParallel);
    const {
      onCurrencyComboboxLoadData,
      selectCurrency,
      onActionBlur,
      currencyCode,
      totalAmountComputed,
      assignValueCurrency,
      isFirst,
    } = useCurrencyCombo(comboboxDataRemote, comboboxLoadData, proxy, 'GLVoucherDetails', 'Parallels');
    //#endregion

    /**
     * Định khoản nhanh
     * Nthien4 21.07.2022
     */
    const {refType, clickQuickAccounting, accountingActions, saveAsNewAutoBusiness} =
      useQuickAccountingVoucher({gridDetails: proxy._gridDetails});

    /**
     * Lấy tất cả định khoản nhanh theo loại chứng từ
     * nthien4 21.07.2022
     */
    refType.value = RefType.GLGeneralVoucher;

    const {deleteVoucher} = useCAReceiptSaleDetailData();

    const {clickItemCopyVoucher} = useCopyNewVoucher(proxy, 'GLVoucherDetails');
    /**
     * Action click button Tiện ích
     * NNLINH 25.05.2022
     */
    const clickItemHandle = async item => {
      switch (item.command) {
        // Thêm CT nghiệp vụ khác
        case 'Voucher':
          // check phân quyền tvhien 19.12.2022
          proxy.checkActionPermissionAlert(proxy.$ms.constant.Permission.Add);
          popupUtil.show('GLGeneralVoucherDetail', {
            mode: proxy.$ms.constant.FormState.Add,
          });
          break;
        // Thêm tạm tính thuế
        case 'ProvisionalTaxInCome':
          popupUtil.show('IncomeTaxVoucherPopup');
          break;
        // Thêm quyết toán thuế
        case 'FinalTaxInComeEnterprise':
          // Check đã tạo dữ liệu quyết toán trong năm chưa
          let year = proxy.postedDate.getFullYear();
          let data = await GLVoucherAPI.checkIncurredTaxByYear(
            year,
            proxy.$ms.constant.RefType.GLFinalTaxInComeEnterprise,
            null,
          );
          if (data && data.ref_id != '00000000-0000-0000-0000-000000000000') {
            let customButton = {Yes: 'Xem', No: 'Không'};
            showConfirmValidate(
              `Bạn có muốn xem Chứng từ quyết toán thuế TNDN năm ${year} số <span class='color-green'>${proxy.$ms.commonFn.processXssValue(
                data.ref_no,
              )}</span> không?`,
              'Đã quyết toán thuế TNDN',
              customButton,
            ).then(async answer => {
              if (answer) {
                // đồng ý thì show chi tiết
                popupUtil.show('GLFinalTaxInComeEnterpriseDetail', {
                  mode: proxy.$ms.constant.FormState.View,
                  id: data.ref_id,
                });
              }
            });
          } else {
            popupUtil.show('GLFinalTaxInComeEnterpriseDetail', {
              mode: proxy.$ms.constant.FormState.Add,
            });
          }
          break;
        // Thêm tiền chuyển đi
        case 'BATransferDeposit':
          // phân quyền tvhien 19.12.2022
          proxy.checkActionPermissionAlert(
            proxy.$ms.constant.Permission.Add,
            proxy.$ms.constant.SubSystemCode.BATransferDeposit,
          );
          popupUtil.show('BATransferDepositDetail', {
            mode: proxy.$ms.constant.FormState.Add,
          });
          break;
        // Thêm tiền chuyển đến
        case 'BATransferWithdraw':
          // phân quyền - tvhien 19.12.2022
          proxy.checkActionPermissionAlert(
            proxy.$ms.constant.Permission.Add,
            proxy.$ms.constant.SubSystemCode.BATransferWithDraw,
          );
          popupUtil.show('BATransferWithdrawDetail', {
            mode: proxy.$ms.constant.FormState.Add,
          });
          break;
        // Thêm mới từ CT hiện thời
        case proxy.$ms.constant.Command.Duplicate:
          item.form = item.form ?? 'GLGeneralVoucherDetail';
          item.refType = item.refType ?? proxy.$ms.constant.RefType.GLGeneralVoucher;
          clickItemCopyVoucher(item);
          break;
        // Xóa CT hiện thời
        case proxy.$ms.constant.Command.Delete:
          deleteVoucher(proxy.model);
          break;
        // Cất thành định khoản tự động
        case proxy.$ms.constant.Command.AddAutoBusiness:
          saveAsNewAutoBusiness();
          break;
        // Xem số dư TK
        case proxy.$ms.constant.Command.ViewAccount:
          viewAccount(proxy);
          break;
        // Sao chép chứng từ
        case proxy.$ms.constant.Command.Copy:
          proxy.clickCopyVoucher();
          break;
        //Lấy biên lai
        case 'GetReceipt':
          getReceiptVoucher();
          break;
        case proxy.$ms.constant.Command.GetElectronicTicket:
          getElectronicTicket();
          break;
      }
      proxy.pushTrans(item.command);
    };
    /**
     * Override để lấy thêm dữ liệu chứng từ khi mở form và gán giá trị mặc định 1 số trường
     * NNLINH 24.05.2022
     */
    async function bindData(data) {
      if(data.ref_date > new Date('2024-06-30')){
        isTaxReduction.value = false;
        data.is_tax_reduction = false;
      }
      if (data.ref_id || proxy._formParam.mode == proxy.$ms.constant.FormState.Add) {
        data.total_amount = data.total_amount || 0;
        data.currency_code = data.currency_code || proxy.$t('i18nEnum.Currency.VND');
        data.exchange_rate = data.exchange_rate || 1;
        currencyCode.value = data.currency_code;
        // NHCUONG 23.06.2023: Bổ sung thêm chứng từ tham chiếu
        if (data.VoucherReferences && data.VoucherReferences.length > 0) {
          setVoucherReferenceInfo(
            data.VoucherReferences.map(item => ({
              ...item,
              ref_id: item.to_ref_id,
              ref_no: item.to_ref_no,
              ref_type: item.to_ref_type,
              budget_source_id: item.from_budget_source_id,
              budget_kind_item_code: item.from_budget_kind_item_code,
              budget_sub_kind_item_code: item.from_budget_sub_kind_item_code,
              budget_chapter_code: item.from_budget_chapter_code,
              budget_item_code: item.from_budget_item_code,
              budget_sub_item_code: item.from_budget_sub_item_code,
              task_id: item.from_task_id,
              statistic_id: item.from_statistic_id,
              project_id: item.from_project_id
            }))
          );
        } else {
          setVoucherReferenceInfo([]);
        }
        isAcceptValidateVoucherReference.value = false;

        const query = new URLSearchParams(window.location.search);
        if (query.has('IsFromInitForm') && query.get('IsFromInitForm') == 'true') {
          // Xet lại giá ngày hạch toán vè 31/12/năm HT
          let year = proxy.$store.state.context.PostedDate.getFullYear();
          let dataBind = new Date(`${year}-12-31`);
          data.ref_date = dataBind;
          data.posted_date = dataBind;
        }
        proxy.super('bindData', baseDetailVoucher, data);
        // sinh hạch toán đồng thời
        if (proxy._formParam && proxy._formParam.data && proxy._formParam.data.IsGenerateData) {
          await proxy.generateParallel(true, true);
          assignDataEmptyToParallel(proxy);
        }
        proxy.super('setOldDataItem', baseDetailVoucher, proxy.model);
        if (proxy.viewing) {
          if (proxy.model.is_posted) {
            stepsDynamic.value = steps.value.filter(x => x.state.includes('posted') || x.state.includes('default'));
          } else {
            stepsDynamic.value = steps.value.filter(x => x.state.includes('unposted') || x.state.includes('default'));
          }
        } else {
          stepsDynamic.value = steps.value.filter(x => x.state.includes('edit') || x.state.includes('default'));
        }
      }
      if (proxy?.offlineReady) {
        data.posted_date = proxy.postedDate;
        data.ref_date = proxy.postedDate;
      }
      proxy.refNoBeforeUpdate = JSON.stringify(data?.ref_no);
    }

    /**
     * Xử lý bind data khi sinh chứng từ từ hóa đơn
     * NNLINH 16.09.2022
     */
    async function beforeBindData() {
      const me = proxy;
      if (
        proxy._formParam &&
        proxy._formParam.data &&
        proxy._formParam.data.IsInvoiceGenerateData &&
        proxy.editMode === proxy.$ms.constant.FormState.Add
      ) {
        // Lấy lại dữ liệu autoID...
        let data = await proxy.loadData('New', {
          mode: proxy.$ms.constant.FormState.Add,
        });

        //Trường hợp sinh từ hóa đơn
        me.model = proxy._formParam.data;
        me.model.ref_no = data.ref_no;
        me.model.ref_type = data.ref_type;
        me.model.ref_id = commonFn.generateUUID();
        bindDataWithInvoiceGenerate();
      }
      // Trường hợp hạch toán chi phí lương và bảo hiểm (Salagov) NHANH3 15.2.2023
      else if (
        proxy._formParam &&
        proxy._formParam.data &&
        proxy._formParam.IsAccountingSalaryAndInsurance &&
        proxy.editMode === proxy.$ms.constant.FormState.Add
      ) {
        // Lấy lại dữ liệu autoID...
        let data = await proxy.loadData('New', {
          mode: proxy.$ms.constant.FormState.Add,
        });

        //Trường hợp sinh
        me.model = proxy._formParam.data;
        me.model.ref_no = data.ref_no;
        me.model.posted_date = proxy.postedDate;
        me.model.ref_date = proxy.postedDate;
        me.model.ref_type = data.ref_type;
        me.model.ref_no = data.ref_no;
        me.model.Parallels = [];
      } else if (
        //sinh từ biên lai
        proxy._formParam &&
        proxy._formParam.lstRefIdSelect &&
        proxy._formParam.isReceiptGenerateData &&
        proxy.editMode === proxy.$ms.constant.FormState.Add
      ) {
        let payload = {
          isGroup: proxy._formParam?.isGroup,
          refIds: proxy._formParam.lstRefIdSelect,
          refType: proxy.model.ref_type,
        };
        //Lấy dữ liệu biên lai sinh chứng từ
        let dataGen = await sAReceiptAPI.getDataGenerateReceipt(payload);
        BindDataGenerateReceipt(dataGen);
      } else if (
        //sinh từ vé điện tử
        proxy._formParam &&
        proxy._formParam.lstRefIdSelect &&
        proxy._formParam.isTicketGenerateData &&
        proxy.editMode === proxy.$ms.constant.FormState.Add
      ) {
        let payload = {
          refIds: proxy._formParam.lstRefIdSelect,
          refType: proxy.model.ref_type,
        };
        //Lấy dữ liệu biên lai sinh chứng từ
        let dataGen = await sAElectronicTicketAPI.getDataGenerateTicket(payload);
        BindDataGenerateReceipt(dataGen);
      } else if (
        // sinh từ Hướng dẫn quyết toán - kiểm tra TSCĐ có kết nối QLTS
        proxy._formParam &&
        proxy._formParam.data &&
        proxy._formParam.data.IsFromHelpSettlementQLTS41 &&
        proxy.editMode === proxy.$ms.constant.FormState.Add
      ){
        var adjustmentData = {};
        var account = await accountAPI.getFirstDetailAccount({accountNumber : '36611'})
        var amount = Math.abs(proxy._formParam.data.DiffAmount);
        if(proxy._formParam.data.AccountNumber.startsWith('214')){
          // chênh lệch khấu hao/hao mòn
          if(proxy._formParam.data.DiffAmount>0){
            me.model.journal_memo = 'Điều chỉnh giảm hao mòn/khấu hao TSCĐ';
            adjustmentData = {
              description : me.model.journal_memo,
              debit_account : proxy._formParam.data.AccountNumber,
              credit_account : account.account_number,
              amount : amount,
              amount_oc : amount,
              state: 1
            };
          }else{
            me.model.journal_memo = 'Điều chỉnh tăng hao mòn/khấu hao TSCĐ';
            adjustmentData = {
              description : me.model.journal_memo,
              debit_account : account.account_number,
              credit_account : proxy._formParam.data.AccountNumber,
              amount : amount,
              amount_oc : amount,
              state: 1
            };
          }
        }else{
          // chênh lệch nguyên giá
          if(proxy._formParam.data.DiffAmount>0){
            me.model.journal_memo = 'Điều chỉnh giảm nguyên giá TSCĐ';
            adjustmentData = {
              description : me.model.journal_memo,
              debit_account : account.account_number,
              credit_account : proxy._formParam.data.AccountNumber,
              amount : amount,
              amount_oc : amount,
              state: 1
            };
          }else{
            me.model.journal_memo = 'Điều chỉnh tăng nguyên giá TSCĐ';
            adjustmentData = {
              description : me.model.journal_memo,
              debit_account : proxy._formParam.data.AccountNumber,
              credit_account : account.account_number,
              amount : amount,
              amount_oc : amount,
              state: 1
            };
          }
        }
        bindDefaultData(proxy.$refs['refDetail'], proxy, 0); // refDetail là key bảng hạch toán
        Object.assign(proxy.model.GLVoucherDetails[0], {
          ...adjustmentData,
        });
        
      }else {
        proxy.super('beforeBindData', baseDetailVoucher);
      }
    }

    /***
     * Hàm lấy mapping dữ liệu với dữ liệu của hóa đơn
     * NNLINH 16.09.2022
     * DVMINH binding thêm trường thông tin cho hóa đơn Bug 417926 31/01/2023
     */
    async function bindDataWithInvoiceGenerate() {
      const me = proxy;
      me.model.ref_type = proxy._formParam.refType;

      //Lấy danh sách tk con chi tiết nhất từ tk cha truyền vào
      let listAcc = await sASaleInvoiceAPI.getChildAccount(proxy.$ms.constant.AccountNumber.SaleInvoice);
      // Lấy tk có chi tiết nhất
      let creditAcc = listAcc.filter(e => e.account == '531').map(e => e.account_detail)[0];
      //Lấy tk nợ chi tiết nhất
      let debitAcc = listAcc.filter(e => e.account == '131').map(e => e.account_detail)[0];
      //Lấy tk thuế chi tiết nhất
      let taxAcc = listAcc.filter(e => e.account == '33311').map(e => e.account_detail)[0];
      //Bind dữ liệu master
      me.model.currency_code = proxy.$t('i18nEnum.Currency.VND');
      me.model.exchange_rate = 1;
      if (!me.model.inv_date) {
        me.model.inv_date = proxy.postedDate;
      }
      me.model.posted_date = me.model.inv_date;
      me.model.ref_date = me.model.inv_date;
      if (me.model.accounting_object_name) {
        me.model.journal_memo = 'Bán hàng cho {0}'.format(me.model.accounting_object_name);
        // DVMINH case cắt đi đoạn này để không bị dài quá ký tự
        if(me.model.journal_memo.length > 255){
          me.model.journal_memo = me.model.journal_memo.substring(0,255);
        }
      }
      //Khởi tạo dữ liệu grid
      me.model.GLVoucherDetails = [];

      me.model.Parallels = [];
      me.model.Details.forEach(e => {
        //Bind dữ liệu cho tab hạch toán
        let newGLVoucher = {
          ref_id: me.model.ref_id,
          ref_detail_id: commonFn.generateUUID(),
          amount: e.amount - e.discount_amount,
          amount_oc: e.amount - e.discount_amount,
          debit_account: debitAcc,
          credit_account: creditAcc,
          description: e.description,
          debit_accounting_object_code: me.model.accounting_object_code,
          debit_accounting_object_id: me.model.accounting_object_id,
          state: 1,
          inv_no: me.model.inv_no,
          inv_date: me.model.inv_date
        };
        if (e.ListSaleInvoiceId) {
          newGLVoucher.ListSaleInvoiceId = e.ListSaleInvoiceId.map(x => x);
        } else {
          newGLVoucher.ListSaleInvoiceId = [];
        }
        me.model.GLVoucherDetails.add(newGLVoucher);

        // HMDUC2 31/05/2024: Nếu như tính thuế PP trực tiếp không sinh thêm dòng thuế suất
        // và số tiền = thành tiền - ck,giảm giá - thuế GTGT
        if (isDirectMethodTax.value) {
          newGLVoucher.amount = newGLVoucher.amount - e.tax_amount;
          newGLVoucher.amount_oc = newGLVoucher.amount_oc - e.tax_amount;
        } else {
          // nếu có thuế suất
          if (e.tax_amount && e.tax_amount != 0) {
            let newGLVoucherTax = {
              ListSaleInvoiceId: [],
              ref_id: me.model.ref_id,
              ref_detail_id: commonFn.generateUUID(),
              amount: e.tax_amount,
              amount_oc: e.tax_amount,
              debit_account: debitAcc,
              credit_account: taxAcc,
              description: e.description,
              debit_accounting_object_code: me.model.accounting_object_code,
              debit_accounting_object_id: me.model.accounting_object_id,
              state: 1,
              inv_no: me.model.inv_no,
              inv_date: me.model.inv_date,
            };
            me.model.GLVoucherDetails.add(newGLVoucherTax);
          }
        }
        e.inv_no = me.model.inv_no;
        e.inv_date = me.model.inv_date;
      });

      //bind dữ liệu tab thuế
      let taxAmount = 0;
      me.model.Details.forEach(e => {
        if (e.tax_amount && e.tax_amount != 0) {
          taxAmount += e.tax_amount;
        }
      });

      me.model.GLVoucherDetailTaxs = [];
      // HMDUC2: Nếu tính thuê theo PP trực tiếp
      if (isDirectMethodTax.value) {
        me.model.Details?.forEach(e => {
          let detailTaxs = {
            ref_id: me.model.ref_id,
            ref_detail_id: commonFn.generateUUID(),
            description: e.description,
            accounting_object_code: me.model.accounting_object_code,
            accounting_object_name: me.model.accounting_object_name,
            accounting_object_address: me.model.accounting_object_address,
            accounting_object_id: me.model.accounting_object_id,
            state: 1,
            industry_group_rate: taxDirectMethodValue.includes(e?.tax_rate) ? e?.tax_rate : '',
          };

          // HMDUC2: Nếu là như lập nhiều từ hóa đơn thì không bind các thông tin mấu số, ký hiệu, số hóa đơn, ngày hóa đơn theo tài liệu
          if(!proxy._formParam.hasOwnProperty('isCreateFromMulti') && !proxy?._formParam?.isCreateFromMulti){
            detailTaxs.inv_date = proxy.model?.inv_date,
            detailTaxs.inv_no = proxy.model?.inv_no,
            detailTaxs.inv_series = proxy.model?.inv_series,
            detailTaxs.inv_type_code = proxy.model?.inv_template_no,
            detailTaxs.inv_type = proxy.model?.inv_type
          }

          me.model.GLVoucherDetailTaxs.add(detailTaxs);
        });
      } else {
        me.model.GLVoucherDetailTaxs = [
          {
            ref_id: me.model.ref_id,
            ref_detail_id: commonFn.generateUUID(),
            tax_rate: -1,
            tax_amount: taxAmount,
            inv_type: me.model.inv_type,
            accounting_object_code: me.model.accounting_object_code,
            accounting_object_name: me.model.accounting_object_name,
            accounting_object_address: me.model.accounting_object_address,
            accounting_object_id: me.model.accounting_object_id,
            state: 1,
            inv_no: me.model.inv_no,
            inv_date: me.model.inv_date,
            inv_series: me.model.inv_series,
            inv_type_code: me.model.inv_template_no,
          },
        ];
      }

      //Gắn lại thông tin ngầm định MLNS
      me.model.GLVoucherDetails.forEach(e => {
        //#region Gắn lại thông tin MLNS ngầm định
        // Nguồn
        if (me.dbOptions.DefaultBudgetSourceID) {
          e.budget_source_id = me.dbOptions.DefaultBudgetSourceID;
          e.budget_source_name = me.dbOptions.DefaultBudgetSourceName;
          // lấy thêm DefaultBudgetSourceGroupPropertyType
          e.budget_source_group_property_type = me.dbOptions.DefaultBudgetSourceGroupPropertyType;
        }

        // Chương
        if (me.dbOptions.DefaultBudgetChapterCode) {
          e.budget_chapter_code = me.dbOptions.DefaultBudgetChapterCode;
          e.budget_chapter_id = me.dbOptions.DefaultBudgetChapterId;
        }

        // Loại
        if (me.dbOptions.DefaultBudgetKindItemCode) {
          e.budget_kind_item_code = me.dbOptions.DefaultBudgetKindItemCode;
          e.budget_kind_item_id = me.dbOptions.DefaultBudgetKindItemId;
        }

        // Khoản
        if (me.dbOptions.DefaultBudgetSubKindItemCode) {
          e.budget_sub_kind_item_code = me.dbOptions.DefaultBudgetSubKindItemCode;
          e.budget_sub_kind_item_id = me.dbOptions.DefaultBudgetSubKindItemId;
        }

        // nghiệp vụ
        if (me.dbOptions.DefaultCashWithDrawTypeID != null && me.dbOptions.DefaultCashWithDrawTypeID != undefined) {
          e.cash_withdraw_type_id = me.dbOptions.DefaultCashWithDrawTypeID;
          e.cash_withdraw_type_name = me.$ms.format.formatData(me.dbOptions.DefaultCashWithDrawTypeID, {
            formatType: 100,
            enumName: 'CashWithDrawType',
          });
        }

        // Hình thức cấp phát
        if (me.dbOptions.DefaultMethodDistributeID != null && me.dbOptions.DefaultMethodDistributeID != undefined) {
          e.method_distribute_type = me.dbOptions.DefaultMethodDistributeID;
          e.method_distribute_name = me.$ms.format.formatData(me.dbOptions.DefaultMethodDistributeID, {
            formatType: 100,
            enumName: 'MethodDistributeType',
          });
        }
        // Loại quỹ
        if (me.dbOptions.DefaultFundID) {
          e.fund_id = me.dbOptions.DefaultFundID;
          e.fund_code = me.dbOptions.DefaultFundCode;
        }
        //#endregion
      });
    }

    // Validate tài khoản và nguồn
    const {onPosted, customUnPostedSuccess} = useValidateBudgetSourceAccount();

    //#endregion
    /**
     * Xử lý value trên grid
     */
    const changeDataBusiness = ($grid, col, rowIndex, metaData, callbackUpdateRow) => {
      let rowData = $grid.dataView[rowIndex]; //lấy ra dữ liệu của hàng đang sửa
      const {dataField} = col;
      const {tracking} = metaData;
      changeDataBusinessCommon($grid, col, rowIndex, metaData, callbackUpdateRow, dataField, tracking);
      switch (dataField) {
        case 'accounting_object_code': // Đối tượng
          callbackUpdateRow(
            {
              accounting_object_name: metaData.accounting_object_name, // Đối tượng khác
              accounting_object_address: metaData.address, // Địa chỉ
              company_tax_code: metaData.company_tax_code, // MST
            },
            rowIndex,
          );
          break;
        case 'debit_accounting_object_code': // Đối tượng nợ
          callbackUpdateRow(
            {
              debit_accounting_object_id: metaData.accounting_object_id,
              debit_accounting_object_name: metaData.accounting_object_name,
            },
            rowIndex,
          );
          break;
        case 'credit_accounting_object_code': // Đối tượng nợ
          callbackUpdateRow(
            {
              credit_accounting_object_id: metaData.accounting_object_id,
              credit_accounting_object_name: metaData.accounting_object_name,
            },
            rowIndex,
          );
          break;
        case 'topic_code': // đề tài
          callbackUpdateRow(
            {
              topic_id: metaData.topic_id,
            },
            rowIndex,
          );
          break;
        case 'contract_no': // hợp đồng
          callbackUpdateRow(
            {
              contract_id: metaData.contract_id,
            },
            rowIndex,
          );
          break;
        case 'task_code': // nhiệm vụ
          callbackUpdateRow(
            {
              task_id: metaData.task_id,
            },
            rowIndex,
          );
          break;
        case 'turn_over': // Giá tính thuế
          callbackUpdateRow(
            {
              // Tính lại tiền thuế
              tax_amount:
                rowData.tax_rate == proxy.$ms.constant.TaxRateInventory.NoSelected
                  ? 0
                  : ((tracking.newVal ?? 0) * ((rowData.tax_rate ?? 0) / 100)).toRound(),
            },
            rowIndex,
          );
          break;
        case 'tax_rate': // Thuế xuất
          callbackUpdateRow(
            {
              // Tính lại tiền thuế
              tax_amount:
                tracking.newVal == proxy.$ms.constant.TaxRateInventory.NoSelected
                  ? 0
                  : ((rowData.turn_over ?? 0) * (tracking.newVal / 100)).toRound(),
            },
            rowIndex,
          );
          break;
        default:
          break;
      }
    };

    /**
     * Config tùy chỉnh giao diện
     * nthien4 21.07.2022
     */
    const getConfigLayout = () => {
      return {
        layouts: [
          {tag: 'GLVoucherDetailHT', name: 'Hạch toán'},
          {tag: 'GLVoucherDetailSta', name: 'Thống kê'},
          {tag: 'GLVoucherDetailTax', name: 'Thuế', ignoreFields: proxy.getIgnoreFields()},
        ],
      };
    };

    /**
     * Theem IgnoreFields theo dboption
     * lttuan1
     */
    const getIgnoreFields = () => {
      if(proxy.dbOptions?.TaxCalculationMethod == proxy.$ms.constant.TaxCalculationMethod.DeductionMethod){
        return ['industry_group_rate']
      } else {
        return []
      }
    }

    /**
     * Override: Custom các cột khác theo dbOptions
     * nmtuan4 18.08.2022
     */
    function applyColumnByDbOptionCustom(item, dbOptions) {
      switch (item.dataField) {
        // Số CT đối trừ
        case 'industry_group_rate':
          // Nếu PP khấu trừ thì không có cột Nhóm ngành nghề
          if (dbOptions?.TaxCalculationMethod == proxy.$ms.constant.TaxCalculationMethod.DeductionMethod) {
            item.visible = false;
          }
          break;
        default:
          break;
      }
    }

    /**
     * Xử lý value trên grid
     */
    const {
      afterDeleteRow,
      changeDataBusinessCommon,
      defaultData,
      getDataDefault,
      bindDefaultData,
      copyDownRow,
      copyActionClick,
      assignDataEmptyToParallel,
    } = useActionGridEditor(proxy);

    getDataDefault(proxy.$ms.constant.RefType.GLGeneralVoucher);

    /**
     * custom dữ liệu mặc định bind vào grid
     * nthien4 07.09.2022
     */
    function customDefaultData($grid, me, rowIndex) {
      $grid.dataView[rowIndex].tax_rate = proxy.$ms.constant.TaxRateInventory.NoSelected ; // Bind mặc định thuế xuất
      // Bind mặc định loại hóa đơn
      $grid.dataView[rowIndex].inv_type = proxy.$ms.constant.InvType.InvoiceGTGT;

      // PBI 451605: Thêm dữ liệu mặc định grid thuế
      if(currentLayout.value == 'GLVoucherDetailTax'){
        $grid.dataView[rowIndex].industry_group_rate = me.$ms.constant.TaxCalculationOccupation.ConstructionNotIncludeMaterials;
      }
    }

    /**
     * Hàm ẩn hiện checkbox giảm 20% GTGT khi sửa ngày HT
     * lttuan1 22.05.2024
     */
    function validateRefDate(newVal){
      if(newVal > new Date(proxy.$ms.constant.FixValue.TaxReductionPeriod)){
        isTaxReduction.value = false;
        proxy.model.is_tax_reduction = false;
      }
      else{
        isTaxReduction.value = true;
        proxy.model.is_tax_reduction = proxy.model?.is_tax_reduction ?? false;
      }
    }

    /**
     * custom hiển thị thêm cột quy đổi trên grid
     * nthien4 07.09.2022
     * nvtoan2 16/05/2023: disabled các cột nếu đang là đối chiếu dữ liệu
     */
    function customColumns(columns) {
      isFirst.value = false;
      if (proxy.model.currency_code && proxy.model.currency_code != proxy.$t('i18nEnum.Currency.VND')) {
        columns.forEach(item => {
          if (item.dataField == 'amount') {
            item.visible = true;
          } else if (item.dataField == 'amount_oc') {
            item.formatType = proxy.$ms.constant.FormatType.AmountOC;
          }
        });
        proxy.columnsDataParalell.forEach(item => {
          if (item.dataField == 'amount') {
            item.visible = true;
          } else if (item.dataField == 'amount_oc') {
            item.formatType = proxy.$ms.constant.FormatType.AmountOC;
          }
        });
      }

      //disabled các cột nếu đang là đối chiếu dữ liệu
      if (proxy.isFromCompareConvert) {
        let dataFieldEditable = ['debit_accounting_object_code', 'credit_accounting_object_code'];

        columns.forEach(x => {
          if (!dataFieldEditable.includes(x.dataField)) {
            x.editable = false;
          }
        });
      }
        // HMDUC2 23/05/2024: Custom enum cho cột thuế suất nếu chọn PP trực tiếp
      if(layoutTagDetail.value === 'GLVoucherDetailTax' && isDirectMethodTax.value && Array.isArray(columns)){
        columns.forEach(col =>  {
          if(col.dataField === 'tax_rate'){
            col.enum = 'TaxRateDirectMethod';
          }
        })
      };
    }

    const {configColumnParalell} = useActionParallel();

    /**
     * Override Lấy ra entity hạch toán đồng thời => đoạn này dev cần cấu hình để lấy chính xác entity, tạm lấy theo columns grid hạch toán đồng thời
     * @returns Model hạch toán đồng thời dạng: [{dataField: "field1"},{dataField: "field2"}]
     * nthien4
     */
    function getParallelModel() {
      if (!this.gridDetailParallel) {
        return {};
      }
      return configColumnParalell;
      // với các chứng từ có thêm các cột trên grid Hạch toán đồng thời khác các cột trên thì phải concat thêm
    }

    /**
     * Lấy dữ liệu cất: Bổ sung thêm ref_type
     * NOTE: 1 form Detail có 2 refType thì cần override để truyền lại reftype
     * nthien4 07.09.2022
     * */
    function getSaveData(mode, action) {
      let me = this;
      let data = me.super('getSaveData', baseDetailVoucher, mode, action);

      data.amount_oc = data.amount;
      if (data.GLVoucherDetails && data.GLVoucherDetails.length > 0) {
        data.GLVoucherDetails.forEach(x => {
          if (!x.ref_type) {
            x.ref_type = me.$ms.constant.RefType.GLGeneralVoucher;
          }
        });
      }
      if (data.GLVoucherDetailTaxs && data.GLVoucherDetailTaxs.length > 0) {
        data.GLVoucherDetailTaxs.forEach(x => {
          if (!x.ref_type) {
            x.ref_type = me.$ms.constant.RefType.GLGeneralVoucher;
          }
        });
      }
      if (data.Parallels && data.Parallels.length > 0) {
        data.Parallels.forEach(x => {
          if (!x.ref_type) {
            x.ref_type = me.$ms.constant.RefType.GLGeneralVoucher;
          }
        });
      }
      // có sinh từ hóa đơn
      if (data.IsInvoiceGenerateData) {
        let ListSaleInvoiceId = [];
        proxy.model.GLVoucherDetails.filter(x => x.state == 1).forEach(e => {
          if (e.ListSaleInvoiceId) {
            e.ListSaleInvoiceId.forEach(re => {
              if (!ListSaleInvoiceId.includes(re)) {
                ListSaleInvoiceId.push(re);
              }
            });
          }
        });
        data.ListSaleInvoiceId = ListSaleInvoiceId;
      }

      // NHCUONG 23.06.2023: Bổ sung thêm lưu chứng từ tham chiếu
      if (voucherReferenceItems.value.length > 0) {
        const refDetailIds = voucherReferenceItems.value.map(item => item.from_ref_detail_id);

        const voucherReferences = proxy.model.GLVoucherDetails.filter(item => {
          if (refDetailIds.includes(item.ref_detail_id)) {
            const voucherReference = voucherReferenceItems.value.find(
              vourcher => vourcher.from_ref_detail_id === item.ref_detail_id,
            );
            if (
              voucherReference &&
              voucherReference.budget_source_id === item.budget_source_id &&
              voucherReference.budget_kind_item_code === item.budget_kind_item_code &&
              voucherReference.budget_sub_kind_item_code === item.budget_sub_kind_item_code &&
              voucherReference.budget_chapter_code === item.budget_chapter_code &&
              voucherReference.budget_item_code === item.budget_item_code &&
              voucherReference.budget_sub_item_code === item.budget_sub_item_code &&
              voucherReference.task_id === item.task_id &&
              voucherReference.statistic_id === item.statistic_id &&
              voucherReference.project_id === item.project_id
            )
              return item;
          }
        });
        if (voucherReferences.length > 0) {
          data.VoucherReferences = voucherReferences.map(item => ({
            ...item,
            to_ref_id: voucherReferenceItems.value[0]?.ref_id,
            to_ref_no: voucherReferenceItems.value[0]?.ref_no,
            to_ref_type: voucherReferenceItems.value[0]?.ref_type,
            from_budget_source_id: item.budget_source_id,
            from_budget_kind_item_code: item?.budget_kind_item_code,
            from_budget_sub_kind_item_code: item?.budget_sub_kind_item_code,
            from_budget_chapter_code: item?.budget_chapter_code,
            from_budget_item_code: item?.budget_item_code,
            from_budget_sub_item_code: item?.budget_sub_item_code,
            from_task_id: item?.task_id,
            from_statistic_id: item?.statistic_id,
            from_project_id: item?.project_id,
            from_ref_detail_id: item?.ref_detail_id,
          }));
        } else {
          data.VoucherReferences = [];
        }
      } else {
        data.VoucherReferences = [];
      }
      data.IsAcceptValidateVoucherReference = isAcceptValidateVoucherReference.value;
      isAcceptValidateVoucherReference.value = false;
      // nthien4 28/08/23 bsung tham số để check thêm khi online hay offline
      data.isSaveOffline = proxy?.offlineReady;
      if (data.isSaveOffline && !data.state) {
        data.state = proxy.$ms.constant.FormState.Add;
      }
      return data;
    }

    /**
     * Override sự kiện khi đóng form
     * mở lại form hóa đơn khi sinh chứng từ
     * NNLINH 19.09.2022
     */
    function beforeClose(e) {
      if (proxy._formParam.options && typeof proxy._formParam.options.submitData === 'function') {
        proxy._formParam.options.submitData();
      } else {
        proxy.super('beforeClose', baseDetailVoucher, e);
      }
    }

    /**
     *  Sự kiện click vào dòng dữ liệu detail
     */
    const toggleAboveHandlerGrid = (colIndex, rowIndex, $grid, me) => {
      if (me.toggleAbove && ((me._defaultRow && rowIndex >= me._defaultRow) || (!me._defaultRow && rowIndex >= 3))) {
        me.toggleAbove = false;
      }

      // Nếu là dòng đầu thì luồn bind mặc định theo DBOption
      if (!me.dbOptions.AllowCloneDetailVoucherRow) {
        bindDefaultData($grid, me, rowIndex);
      } else if (me.dbOptions.AllowCloneDetailVoucherRow) {
        if (rowIndex == 0 || $grid.dataView[rowIndex - 1].state === me.$ms.constant.ModelState.Empty) {
          bindDefaultData($grid, me, rowIndex);
        } else if (
          rowIndex > 0 &&
          $grid.dataView[rowIndex].state == me.$ms.constant.ModelState.Empty &&
          $grid.dataView[rowIndex - 1].state !== me.$ms.constant.ModelState.Empty
        ) {
          // Dòng thì 2 trở đi thì check DBOption xem có sao chép dòng ko
          $grid.dataView[rowIndex] = cloneRow(rowIndex - 1, $grid.dataView[rowIndex], $grid, me);
        }
      }
    };

    /**
     * Copy dữ liệu từ dòng thứ 2
     */
    function cloneRow(rowIndex, item, $grid, me) {
      let preRow = _.cloneDeep($grid.dataView[rowIndex]);

      let clearFields = ['state', 'ref_id', 'ref_detail_id', 'amount', 'amount_oc'];

      clearFields.forEach(field => delete preRow[field]);

      Object.assign(item, {...preRow});
      item.state = me.$ms.constant.ModelState.Empty;
      return item;
    }
    /**
     * Override hàm check ghi sổ chi tiết theo từng tài khoản
     * modified by dtnga3 (21.04.2023) Sửa lỗi thông báo lỗi khi 1 tk (bị lỗi) hạch toán ở cả cột tk nợ và tk có
     */
    function getResultGrid(arr, mapField, data, mapData) {
      const me = this;
      let dataFilter = data.filter(x => x.credit_account || x.debit_account);
      return arr
        .filter(x => x.value.length)
        .map(x => {
          let keys = x.value;
          let fields = keys.filter(key => {
            // case trường hợp đối tượng nợ, đối tượng có để gán lại mapField cho đúng
            let objMapfield = mapField.find(t => t.field == key);

            if (objMapfield && objMapfield.mapField) {
              let field = objMapfield.mapField;
              let err = false;
              if (objMapfield.isCheckAll) {
                return (
                  data.filter(o => o.debit_account == x.key || o.credit_account == x.key).some(row => !row[field]) &&
                  !me.model[field]
                );
              } else {
                if (objMapfield.field == 'is_detail_by_accounting_object') {
                  // kiểm tra cả tk nợ và tk có
                  let findDataDebit = dataFilter.find(n => n.debit_account == x.key);
                  if (findDataDebit) {
                    // là tài khoản nợ
                    objMapfield.mapField = 'debit_accounting_object_code';
                    err = data.filter(o => o.debit_account == x.key).some(row => !row['debit_accounting_object_code']);
                  }

                  if (!err) {
                    let findDataCredit = dataFilter.find(n => n.credit_account == x.key);
                    if (findDataCredit) {
                      // Là tài khoản có
                      objMapfield.mapField = 'credit_accounting_object_code';
                      err = data
                        .filter(o => o.credit_account == x.key)
                        .some(row => !row['credit_accounting_object_code']);
                    }
                  }
                  return err;
                } else {
                  return data
                    .filter(o => o.debit_account == x.key || o.credit_account == x.key)
                    .some(row => !row[field]);
                }
              }
            } else {
              return false;
            }
          });

          return {
            key: x.key,
            field: fields,
            mapField: mapField
              .filter(t => fields.includes(t.field))
              .map(t => {
                return {
                  mapField: t.mapField,
                  isCheckAll: t.isCheckAll ? t.isCheckAll : false,
                };
              }),
            build: fields.map(t => mapData[t]),
          };
        })
        .filter(x => x.field.length);
    }

    /**
     * Hàm click button sửa
     * NNLINH 21.09.2022
     */
    async function clickEdit() {
      let payload = {
        id: proxy.model.ref_id,
        type: 2,
      };
      // check phân quyền tvhien 19.12.2022
      proxy.checkActionPermissionAlert(proxy.$ms.constant.Permission.Edit);
      let data = await sASaleInvoiceAPI.checkDataReference(payload);
      let message;
      //nếu có mã hóa đơn thì thông báo cảnh báo
      if (data && data.ListInvoiceReference) {
        //hiện cảnh báo
        let refNo = '';
        //Lấy danh sách mã hóa đơn liên quan
        if (data && data.ListInvoiceReference && data.ListInvoiceReference.length) {
          refNo = data.ListInvoiceReference.map(x => {
            return (
              (x.inv_form_number == null ? '' : '{0} - '.format(x.inv_form_number)) +
              (x.inv_series == null ? '' : '{0} - '.format(x.inv_series)) +
              (x.inv_no == null ? '' : '{0}'.format(x.inv_no))
            );
          }).join('; ');
        }
        if (data.is_receipt) {
          message =
            'Chứng từ nghiệp vụ khác đã lập biên lai <span class="color-blue">{0}</span>. Sau khi sửa bạn vui lòng vào cập nhật các biên lai trên để dữ liệu được chính xác. Bạn có muốn sửa không?'.format(
              refNo,
              proxy.model.ref_no,
            );
        } else if (data.is_ticket) {
          message =
            'Chứng từ nghiệp vụ khác đã lập vé điện tử <span class="color-blue">{0}</span>. Sau khi sửa bạn vui lòng vào cập nhật các vé điện tử trên để dữ liệu được chính xác. Bạn có muốn sửa không?'.format(
              refNo,
              proxy.model.ref_no,
            );
        } else {
          message =
            'Chứng từ nghiệp vụ khác đã lập hóa đơn <span class="color-blue">{0}</span>. Sau khi sửa chứng từ này, bạn phải vào cập nhật lại các hóa đơn trên cho đúng. Bạn có muốn sửa không?'.format(
              refNo,
            );
        }
        showConfirm(message, 'Sửa chứng từ nghiệp vụ khác').then(answer => {
          if (answer) {
            proxy.setFormMode(proxy.$ms.constant.FormState.Edit);
          }
        });
      }
      //Nếu ko có reference thì chuyển mode sửa
      else {
        proxy.setFormMode(proxy.$ms.constant.FormState.Edit);
      }
    }

    /**
     * Mở in chứng từ
     * TPNAM 05.10.2022
     */
    function itemCLick(report) {
      proxy.printVoucher(report);
    }
    /**
     * in chứng từ
     */
    function printVoucher(report) {
      const me = proxy;
      if (!report || !report.report_id) {
        return;
      }
      let param = {
        ReportId: report.report_id,
        ReportName: report.report_name,
        // ReportTitle: report.report_name,
        // ReportSubTitle: report.report_name,
        ReportList: report,
        DataParam: {
          refIds: [me.model.ref_id],
          ref_type: me.model.ref_type,
          ref_id: me.model.ref_id,
          $ListRefID: report?.list_ref_id || me.model.ref_id || report?.ref_id,
          $RefType: report?.ref_type,
          ViewReceiptFullAmount: report?.view_receipt_full_amount,
          PrintInfomationReceiptUnit: report?.print_information_receipt_unit,
          PrintSystemDate: report?.print_system_date,
          PrintVourcherDate: report?.print_voucher_date,
          PrintPreview: report?.print_voucher_preview,
          AllowBatchPrinting: report?.allow_batch_printing,
          DateTimeReport: report?.print_system_date ? me.postedDate : null,
          $PrintedType: report?.printed_type || 2,
          $OrderBy: report?.order_by || '',
          $BankAccountAdjustment: '',
          $BankAccountWithdraw: '',
          $IsPrintDetail: false,
        },
      };
      const customParams = me.getCustomReportParams(report.report_id);
      if (customParams) {
        param.DataParam = {...param.DataParam, ...customParams};
      }

      const templateParams = me.getTemplateParams(report.report_id);
      if (templateParams) {
        param.TemplateParam = {...templateParams};
      }
      report = me.customReport(report);
      if (report && report.allow_batch_printing) {
        let param = proxy._formParam;
        const formReportSetting = commonFn.formChooseReportSettingFactory(report.ref_type);
        popupUtil.show(formReportSetting, {
          ...report,
          ...me.model,
          model: report,
          ...{
            detailForm: proxy.$options?.name,
          },
        });
      } else {
        me.print(report, param);
      }
    }
    function getLoadDataParameter(action, paramRequest) {
      proxy.settlementID = paramRequest.settlementID;

      return proxy.super('getLoadDataParameter', baseDetailVoucher, action, paramRequest);
    }
    /**
     * Hàm xử lý sau khi cất
     * gắn lại hiển thị đã lập hóa đơn
     * NNLINH 10.10.2022
     */
    function afterSubmitModeView(result, param) {
      if (proxy._formParam && proxy._formParam.data && proxy._formParam.data.IsInvoiceGenerateData) {
        result.IsInvoiceGenerateData = true;
        //Update lại hạch toán màn hình danh sách
        proxy.$store.dispatch('sASaleInvoice/updatedPosted', result.ListSaleInvoiceId);
      }
      ///12.04.2023 nnlinh bổ sung cập nhập lại màn hình danh sách biên lai
      if (proxy._formParam && proxy._formParam.isReceiptGenerateData) {
        //Update lại hạch toán màn hình danh sách
        proxy.$store.dispatch('sAReceipt/updatedPosted', result.ListSAReceiptId);
      }

      ///19.09.2023 nnlinh bổ sung cập nhập lại màn hình danh sách vé điện tử
      if (proxy._formParam && proxy._formParam.isTicketGenerateData) {
        //Update lại hạch toán màn hình danh sách
        proxy.$store.dispatch('sAElectronicTicket/updatedPosted', result.ListSATicketId);
      }
      //06.11.2023 cập nhật lại màn hình danh sách inbot
      if (proxy._formParam && proxy._formParam.dataInbot && proxy._formParam.dataInbot.ListInvoiceInbot?.length > 0) {
        //Update lại hạch toán màn hình danh sách
        let payload = {
          ids: proxy._formParam.dataInbot.ListInvoiceInbot,
          isPosted: true,
          refNo: result.ref_no,
          isUpdatePosted: true,
          refNoBeforeUpdate: JSON.parse(proxy.refNoBeforeUpdate)
        };
        proxy.$store.dispatch('moduleInvoiceBot/updatedPosted', payload);
      }
      proxy.super('afterSubmitModeView', baseDetailVoucher, result, param);
    }

    /**
     * Custom gọi hàm sinh dữ liệu
     * NNLINH 03.11.2022
     */
    function customVoucherLoadData(result) {
      if (
        proxy._formParam &&
        proxy._formParam.data &&
        proxy._formParam.data.IsGenerateData &&
        (proxy.editMode === proxy.$ms.constant.FormState.Add || proxy.editMode === proxy.$ms.constant.FormState.Edit)
      ) {
        Object.assign(result, {
          Id: proxy._formParam.data.ref_id,
          ParamModeAdd: JSON.stringify({
            RefTypeKey: proxy._formParam.refType,
          }),
          IsSyncData: proxy._formParam.data.IsSyncData,
          IsFundSalary: proxy._formParam.IsFundSalary,
          action: 'DataVoucher',
        });
      } else {
        proxy.super('customVoucherLoadData', baseDetailVoucher, result);
      }
    }
    /**
     * Enable Button Delete
     *
     */
    const disabledDelete = computed(() => {
      return proxy.editMode != proxy.$ms.constant.FormState.View || proxy.model.is_posted;
    });
    const stepsDynamic = ref([]);
    /**
     * Dữ liệu step
     */
    const steps = ref([
      {
        target: '.gl-general-voucher-guide',
        header: {
          title: 'Chức năng Hướng dẫn',
        },
        key: 1,
        state: ['default'],
        content: 'Xem hướng dẫn nhanh các thao tác trên màn hình chứng từ',
      },
      {
        target: '.gl-general-voucher-shortkey',
        header: {
          title: 'Phím tắt',
        },
        state: ['default'],
        content: 'Xem danh sách các phím tắt để thao tác nhanh trên phần mềm',
      },
      {
        target: '.setting-small',
        header: {
          title: 'Tùy chỉnh giao diện',
        },
        state: ['default'],
        content: 'Thực hiện tùy chỉnh giao diện chứng từ theo nhu cầu',
      },
      {
        target: '.gl-general-voucher-question',
        header: {
          title: 'Trợ giúp',
        },
        state: ['default'],
        content: 'Xem tài liệu hướng dẫn chi tiết nghiệp vụ',
      },
      // {
      //   target: '.ms-tbody td.inventory_item_code',
      //   header: {
      //     title: 'Chọn mặt hàng',
      //   },
      //   dataField: 'inventory_item_code',
      //   scroll: {
      //     inline: 'start',
      //   },
      //   content: 'Lựa chọn mặt hàng có trong danh sách hoặc thêm nhanh',
      // },
      {
        target: '.ms-tbody .row-editor-action.insert',
        header: {
          title: 'Thêm dòng',
        },
        scroll: {},
        state: ['edit'],
        content: 'Thêm nội dung chứng từ',
      },
      {
        target: '.ms-tbody .row-editor-action.delete',
        header: {
          title: 'Xóa dòng',
        },
        scroll: {},
        state: ['edit'],
        content: 'Xóa nội dung chứng từ',
      },

      {
        target: '.step-close',
        header: {
          title: 'Chức năng',
        },
        state: ['edit'],
        content: `Thực hiện Cất để lưu chứng từ`,
      },
      {
        target: '.step-5-pos',
        header: {
          title: 'Tiện ích',
        },
        state: ['posted', 'unposted'],
        content: 'Tùy chọn các chức năng khác của chứng từ như: Thêm chứng từ mới, Xem số dư tài khoản,...',
      },
      {
        target: '.step-6-pos',
        header: {
          title: 'Chức năng In',
        },
        state: ['posted', 'unposted'],
        content: `Lựa chọn chứng từ để in hoặc thiết lập tùy chọn in theo lô`,
      },
      {
        target: '.step-7-posted',
        header: {
          title: 'Sửa nhanh',
        },
        state: ['posted'],
        content: `Thực hiện sửa một số thông tin chung trên chứng từ`,
      },
      {
        target: '.step-close',
        header: {
          title: 'Bỏ ghi',
        },
        state: ['posted'],
        content: `Bỏ ghi sổ chứng từ để sửa hoặc xóa chứng từ`,
      },
      {
        target: '.step-7-unposted',
        header: {
          title: 'Chức năng Xóa',
        },
        state: ['unposted'],
        content: `Xóa chứng từ hiện thời`,
      },
      {
        target: '.step-8-unposted',
        header: {
          title: 'Sửa',
        },
        state: ['unposted'],
        content: `Sửa chứng từ hiện thời`,
      },
      {
        target: '.step-close',
        header: {
          title: 'Ghi sổ',
        },
        state: ['unposted'],
        content: `Ghi sổ chứng từ hiện thời`,
      },
    ]);

    onMounted(() => {
      /** Dữ liệu step binding */
      proxy.steps = computed(() =>
        steps.value.filter(x => !x.dataField || proxy.gridDetail?.columnx.some(o => o.dataField == x.dataField)),
      );
      // Check xem có tích sử dụng phân hệ thuế hay ko
      let dbOptions = {...proxy.$store.state.dbOption.dbOptions};
      if (dbOptions && typeof dbOptions === 'object') {
        useTA.value = dbOptions.UseTA;
      }
    });

    /**
     * Sửa lỗi validate và custom lại thông báo khi ghi sổ
     * HQMINH 06.03.2023
     */
    const validateAccounting = async () => {
      const me = proxy;

      // Xử lý build message
      let invalid = (await me.validateDetail()) || [];

      let data = me.getSummaryDataGrid('refDetail', 'refDetailParallel', 'refDetailOther');

      invalid.forEach(item => {
        // tìm những build chi tiết theo đối tượng
        if (item.field.find(x => x == 'is_detail_by_accounting_object')) {
          // tìm là tk nợ hay có trên grid
          item.build = item.build.filter(x => x != 'Đối tượng') || [];
          // đối tượng nợ
          if (data.find(x => x.debit_account == item.key && !x.debit_accounting_object_code)) {
            item.build.push('Đối tượng Nợ');
          }
          // đối tượng có
          if (data.find(x => x.credit_account == item.key && !x.credit_accounting_object_code)) {
            item.build.push('Đối tượng Có');
          }
        }
      });

      invalid = invalid.filter(x => x.build.length > 0);

      if (invalid && invalid.length) {
        var mes =
          'Bạn cần nhập các thông tin </br>' +
          invalid
            .map(o => {
              return `- <span class="color-green">${o.build.join(
                '; ',
              )}</span> cho các dòng hạch toán tài khoản <span class="color-green">${o.key}</span></br>`;
            })
            .join(' ') +
          `Nếu bạn không thấy <span class="color-green">` +
          me.$ms.commonFn.distinct(invalid.reduce((obj, x) => [...obj, ...x.build], [])).join('; ') +
          `</span> trên giao diện chứng từ, vui lòng xem hướng dẫn <a target="_blank" href=${proxy.$tm(
            'i18nHelpLink.ErrorPosted',
          )} class='text-link customCallBack'>tại đây</span>.`;
        me.invalidPost = invalid;
        me.resetValidateGrid();
      }
      return mes;
    };

    /**
     * Hàm xử lý lấy biên lai
     * NNLINH 06.04.2023
     */
    function getReceiptVoucher() {
      //Lấy danh sách các biên lai đã lập trên chứng từ -> loại bỏ khi chọn trên form chọn biên lai
      let lstReceiptId = [];
      let detail = proxy.model?.GLVoucherDetails;
      if (detail.length) {
        detail.forEach(x => {
          if (x.state != 3 && x.state != 4) {
            lstReceiptId = lstReceiptId.concat(x.SAReceiptIds);
          }
        });
      }
      popupUtil.show('GetReceiptDataPopup', {
        refType: proxy.$ms.constant.RefType.GLGeneralVoucher,
        lstReceiptId: lstReceiptId,
        options: {
          submit: data => {
            if (data) {
              BindDataGenerateReceipt(data);
            }
          },
        },
      });
    }

    /**
     * Lấy vé điện tử
     * NNLINH 12.09.2023
     */
    function getElectronicTicket() {
      //Lấy danh sách các biên lai đã lập trên chứng từ -> loại bỏ khi chọn trên form chọn biên lai
      let lstTicketId = [];
      let detail = proxy.model?.GLVoucherDetails;
      if (detail.length) {
        detail.forEach(x => {
          if (x.state != 3 && x.state != 4 && x.SATicketIds != null && x.SATicketIds != undefined) {
            lstTicketId = lstTicketId.concat(x.SATicketIds);
          }
        });
      }
      popupUtil.show('GetElectronicTicketDataPopup', {
        refType: proxy.$ms.constant.RefType.GLGeneralVoucher,
        idIgnore: lstTicketId,
        options: {
          submit: data => {
            if (data) {
              BindDataGenerateReceipt(data);
            }
          },
        },
      });
    }

    /**
     * Hàm bind dữ liệu cho chứng từ khi sinh từ biên lai
     * NNLINH 10.04.2023
     */
    function BindDataGenerateReceipt(data) {
      //Gắn lại thông tin master
      //Chỉ gắn thông tin master mode add
      if (proxy.editMode === proxy.$ms.constant.FormState.Add) {
        if (data.ref_date) {
          //Gắn lại ngày ht. ngày ct
          proxy.model.ref_date = data.ref_date;
          proxy.model.posted_date = data.posted_date;
        }
        //Gắn lại thông tin vé điện tử
        proxy.model.IsElectronicTicket = data?.IsElectronicTicket;
      }

      //Gắn dữ liệu detail
      if (data.GLVoucherDetails && data.GLVoucherDetails.length) {
        // lấy ra index lớn nhất
        let indexMax =
          proxy.model.GLVoucherDetails.findLastIndex(x => x.state != proxy.$ms.constant.ModelState.Empty) || 0;

        let restIndex = proxy.model.GLVoucherDetails.length - 1 - indexMax;

        // thêm data.GLVoucherDetails.length - restIndex dòng nữa
        let length = data.GLVoucherDetails.length - restIndex;
        for (let i = 0; i < length; i++) {
          proxy.$refs['refDetail'].addRow(
            proxy.$refs['refDetail'].datax.length,
            proxy.model.GLVoucherDetails.length + i,
            true,
          );
        }

        for (let i = 0; i < data.GLVoucherDetails.length; i++) {
          let item = data.GLVoucherDetails[i];
          item.amount_oc = item.amount;
          item.ref_id = proxy.model.ref_id;
          Object.keys(item).forEach(x => {
            if (!item[x]) {
              delete item[x];
            }
          });

          // lấy default cho data.gridDetail.length dòng
          bindDefaultData(proxy.$refs['refDetail'], proxy, indexMax + i + 1); // refDetail là key bảng hạch toán
          Object.assign(proxy.model.GLVoucherDetails[indexMax + i + 1], {
            ...item,
          });
        }
      }

      //Gắn dữ liệu tab thuế
      if (data.GLVoucherDetailTaxs && data.GLVoucherDetailTaxs.length) {
        // lấy ra index lớn nhất
        let indexMax =
          proxy.model.GLVoucherDetailTaxs.findLastIndex(x => x.state != proxy.$ms.constant.ModelState.Empty) || 0;

        let restIndex = proxy.model.GLVoucherDetailTaxs.length - 1 - indexMax;

        // thêm data.CAReceiptDetail.length - restIndex dòng nữa
        let length = data.GLVoucherDetailTaxs.length - restIndex;
        for (let i = 0; i < length; i++) {
          proxy.$refs['refDetailOther'].addRow(
            proxy.$refs['refDetailOther'].datax.length,
            proxy.model.GLVoucherDetailTaxs.length + i,
            true,
          );
        }

        for (let i = 0; i < data.GLVoucherDetailTaxs.length; i++) {
          let item = data.GLVoucherDetailTaxs[i];
          item.amount_oc = item.amount;
          item.ref_id = proxy.model.ref_id;
          Object.keys(item).forEach(x => {
            if (!item[x]) {
              delete item[x];
            }
          });

          // lấy default cho data.gridDetail.length dòng
          // bindDefaultData(proxy.$refs['refDetailOther'], proxy, indexMax + i + 1); // refDetail là key bảng hạch toán
          Object.assign(proxy.model.GLVoucherDetailTaxs[indexMax + i + 1], {
            ...item,
          });
        }
      }

      let lstSAReceiptId = [];
      proxy.model?.GLVoucherDetails.forEach(x => {
        if (x.state != 3 && x.state != 4 && x.SAReceiptIds) {
          lstSAReceiptId = lstSAReceiptId.concat(x.SAReceiptIds);
        }
      });
      proxy.model.ListSAReceiptId = lstSAReceiptId;

      let lstSATicketId = [];
      proxy.model?.GLVoucherDetails.forEach(x => {
        if (x.state != 3 && x.state != 4 && x.SATicketIds) {
          lstSATicketId = lstSATicketId.concat(x.SATicketIds);
        }
      });
      if (proxy.model.ListSATicketId?.length) {
        proxy.model.ListSATicketId = proxy.model.ListSATicketId.concat(lstSATicketId);
      } else {
        proxy.model.ListSATicketId = lstSATicketId;
      }
    }

    /**
     * Có hiển thị chọn tham chiếu đến chứng từ hay không
     * @author NHCUONG 23.06.2023
     */
    const isShowVoucherReference = computed(() => {
      return refTypeAcceptVoucherReference.value.includes(refType.value);
    });

    /**
     * Hiển thị form tham chiếu Phiếu thu
     * @author NHCUONG 23.06.2023
     */
    function showFormVoucherReference() {
      if (!proxy.viewing)
        popupUtil.show('VoucherReference', {
          postedDate: proxy.model.posted_date,
          RefTypeView: getRefTypeView(),
          options: {
            submit: this.callbackChooseItem.bind(this),
          },
        });
    }

    /**
     * Lấy ref type tham chiếu
     * @author NHCUONG 23.06.2023
     */
    function getRefTypeView() {
      let refTypeView = proxy.$ms.constant.RefType.CAReceiptPlanWithdraw;
      switch (refType.value) {
        case proxy.$ms.constant.RefType.CAReceiptPlanWithdraw:
          refTypeView = proxy.$ms.constant.RefType.CAReceiptPlanWithdraw;
          break;
        case proxy.$ms.constant.RefType.BAWithDraw:
        case proxy.$ms.constant.RefType.BAWithdrawPurchase:
        case proxy.$ms.constant.RefType.BAWithDrawFixedAsset:
        case proxy.$ms.constant.RefType.BAWithdrawVendor:
          refTypeView = proxy.$ms.constant.RefType.BUTransferDeposit;
          break;
        case proxy.$ms.constant.RefType.GLGeneralVoucher:
          refTypeView = proxy.$ms.constant.DefaultValue.All;
          break;
        case proxy.$ms.constant.RefType.BUTransferDeposit:
          refTypeView = proxy.$ms.constant.RefType.BUTransferDeposit;
          break;
      }
      return refTypeView;
    }

    /**
     * Sự kiện khi chọn chứng từ tham chiếu từ grid danh sách
     * @author NHCUONG 23.06.2023
     */
    function callbackChooseItem(items) {
      setVoucherReferenceInfo(items);
      let grid = getGridDetail();
      if (grid) {
        initNewData(grid);
      }
    }

    /**
     * Gán thông tin tham chiéu
     * @author NHCUONG 23.06.2023
     */
    function setVoucherReferenceInfo(data) {
      voucherReferenceItems.value = data;
    }

    /**
     * Lấy grid detail
     * @NHCUONG 23.06.2023
     */
    function getGridDetail() {
      let keys = Object.keys(proxy._gridDetails);
      if (keys && keys.length > 0) {
        let refName = proxy._gridDetails[keys[0]];
        let gridRef = proxy.$refs[refName];
        if (gridRef) {
          return gridRef;
        }
        return null;
      }
      return null;
    }

    /**
     * Gán tiền cho dòng đầu tiên
     * @author NHCUONG 23.06.2023
     */
    function initNewData(grid) {
      if (voucherReferenceItems.value.length === 0) return;
      voucherReferenceItems.value.forEach((item, index) => {
        let col = grid.getColumns()[0];
        if(index > grid.dataView.length - 1){
          grid.addRow(index, index, false, col);
        }
        let rowUpdate = grid.dataView[index];

        item.from_ref_detail_id = rowUpdate.ref_detail_id;

        
        grid.changeEditor(null, index, col).then(() => {
          if (rowUpdate.state === proxy.$ms.constant.ModelState.Empty) {
            rowUpdate.state = proxy.$ms.constant.ModelState.Insert;
          }
          rowUpdate.amount = item?.remaining_amount || 0;
          rowUpdate.amount_oc = item?.remaining_amount || 0;
          rowUpdate.inward_amount = item?.remaining_amount || 0;
          if ((rowUpdate?.quantity || 0) !== 0) {
            rowUpdate.unit_price = rowUpdate.amount / rowUpdate.quantity;
          }
          rowUpdate.description = item?.description;
          rowUpdate.budget_source_id = item?.budget_source_id;
          rowUpdate.budget_source_code = item?.budget_source_code;
          rowUpdate.budget_source_name = item?.budget_source_name;
          rowUpdate.budget_kind_item_code = item?.budget_kind_item_code;
          rowUpdate.budget_sub_kind_item_code = item?.budget_sub_kind_item_code;
          rowUpdate.budget_chapter_code = item?.budget_chapter_code;
          rowUpdate.budget_item_code = item?.budget_item_code;
          rowUpdate.budget_sub_item_code = item?.budget_sub_item_code;

          rowUpdate.task_code = item?.task_code;
          rowUpdate.task_id = item?.task_id;

          rowUpdate.statistic_code = item?.statistic_code;
          rowUpdate.statistic_id = item?.statistic_id;

          rowUpdate.project_code = item?.project_code;
          rowUpdate.project_id = item?.project_id;
        });
      });

      while(grid.dataView.length > voucherReferenceItems.value.length){
        proxy.model.GLVoucherDetails.pop();
      }
    }

    /**
     * Xóa chứng từ tham chiếu
     * @author NHCUONG 23.06.2023
     */
    function removeVoucherReference() {
      voucherReferenceItems.value = [];
    }

    /**
     * Custom hàm thông báo lỗi khi validate tham chiếu chứn từ
     * @author NHCUONG 23.06.2023
     */
    function saveError(error, param, action) {
      // case nếu mất mạng thì show thông báo cất thành công
      if (proxy.offlineReady) {
        // Khi mất mạng, vẫn show cất thành công
        // Chuyển mode về xem
        proxy.editMode = proxy.$ms.constant.FormState.View;
        proxy.$toast.success(proxy.$tm('i18nBaseForm.Message.SaveSuccess'));
      } else {
        isAcceptValidateVoucherReference.value = false;
        let errorData = error.response.data;
        if (errorData.Error === proxy.$ms.constant.ErrorCodes.ValidateAmountVoucherReference) {
          let {Data} = errorData.Data;
          let message = `Số tiền trên chứng từ <span style="font-weight: bold;">${proxy.$ms.commonFn.processXssValue(
            proxy.model.ref_no,
          )}</span> vượt quá số tiền rút dự toán trên chứng từ <span style="font-weight: bold;">${proxy.$ms.commonFn.processXssValue(
            Data.ref_type_name,
          )} - ${proxy.$ms.commonFn.processXssValue(
            Data.ref_no,
          )}</span>. Bạn có muốn ghi sổ (chấp nhận xuất quỹ tiền âm) không?`;
          let title = 'Quỹ tiền âm';
          showConfirm(message, title, 410).then(async answer => {
            if (answer) {
              proxy.super('commandClick', baseDetailVoucher, proxy.$ms.constant.Command.SaveView);
              isAcceptValidateVoucherReference.value = true;
            }
          });
        } else {
          proxy.super('saveError', baseDetail, error, param, action);
        }
      }
    }

    /**
     * Hiển thị target link khi xem chứng từ
     * @author NHCUONG 26.06.2023
     */
    function showTargetLink(item) {
      proxy.super('showTargetLink', baseDetailVoucher, item);
    }

    /**
     * Lập chứng từ từ Hóa đơn xử lý đầu vào
     * NNLINH 06.11.2023
     */
    async function bindDataFromInbot(data, dataInbot, dataInbotDetail, dataInbotTax) {
      Object.assign(data, dataInbot);
      data.GLVoucherDetails = [];
      dataInbotDetail.forEach((detail, index) => {
        detail.sort_order = index;
        // HMDUC2 17/06/2024: Ẩn thông tin Tk nợ, đối tượng nợ, thông tin đối tượng nợ
        detail.debit_accounting_object_code = "";
        detail.debit_accounting_object_id = "";
        detail.debit_accounting_object_name = "";
        detail.debit_account = "";
        data.GLVoucherDetails.push(detail);
      });
      if (dataInbotTax?.length > 0) {
        data.GLVoucherDetailTaxs = [];
        dataInbotTax.forEach((item, index) => {
          item.sort_order = index;
          data.GLVoucherDetailTaxs.push(item);
        });
      }


      //Sinh hạch toán đồng thời
      await proxy.generateParallel(true, true);
    }

    /**
     * Xử lý sau khi xóa chứng từ
     * NNLINH 26.10.2023
     */
    function deleteSuccess(record, result) {
      if (proxy._formParam && proxy._formParam.dataInbot && proxy._formParam.dataInbot.ListInvoiceInbot?.length > 0) {
        //Update lại hạch toán màn hình danh sách
        let payload = {
          ids: proxy._formParam.dataInbot.ListInvoiceInbot,
          isPosted: false,
          refNo: null,
          refNoDelete: record?.ref_no, // HMDUC2 02/01/2023: Lưu lại ref_no ct xóa thành công phục vụ cập nhật lại chứng từ hoạch toán invoicebot_list
        };
        proxy.$store.dispatch('moduleInvoiceBot/updatedPosted', payload);
      }
      proxy.super('deleteSuccess', baseDetailVoucher, record, result);
    }
    const changeTriggers = shallowRef([
      'project_code',
      'budget_sub_kind_item_code',
      'budget_item_code',
      'budget_sub_item_code',
      'budget_detail_item_code',
      'amount_oc',
      'debit_accounting_object_code',
      'credit_accounting_object_code',
      'topic_code',
      'contract_no',
      'task_code',
      'budget_source_name',
      'credit_account',
      'debit_account',
      'project_expense_code',
      'quantity',
      'budget_kind_item_code'
    ]);

    const changeTriggersTax = shallowRef([
      'project_code',
      'amount_oc',
      'accounting_object_code',
      'tax_amount',
      'tax_rate',
      'turn_over',
    ]);

    const changeTriggersHT = shallowRef([
      'budget_kind_item_code',
      'budget_sub_kind_item_code',
      'budget_item_code',
      'budget_sub_item_code',
      'budget_source_name',
      'amount_oc',
      'budget_detail_item_code',
      'credit_account',
      'debit_account',
    ]);
    /**
     * Custom tham số xóa chứng từ
     * TPNAM 28.02.2024
     */
    function getParamDeleteDetail(tempArr){
      return [...tempArr.map(({ ref_id, ref_type, ref_no }) => ({ref_id, ref_type, ref_no }))];
    }

    /**
     * Lấy tên model lưu dữ liệu grid thuế
     */
    function getTaxKeyModel() {
      return "GLVoucherDetailTaxs"
    }

    /**
     * @override lại hàm này để mapping theo đúng bảng
     */
    async function mappingCopyVoucher(itemCopy) {
      let item = proxy.super('mappingCopyVoucher', baseDetailVoucher, itemCopy);
      if (item) {
        item.debit_accounting_object_id = item.accounting_object_id;
        item.debit_accounting_object_code = item.accounting_object_code;
        item.debit_accounting_object_name = item.accounting_object_name;
        item.credit_accounting_object_name = item.credit_accounting_object_name_customize;
      }

      return item;
    }

    /**
     * 
     * @param command Ghi đè hàm gửi lên mcp
     * @param isPrintVoucher 
     * @param report 
     */
    function pushTrans(command, isPrintVoucher = false, report) {
      if(isDirectMethodTax.value && command === proxy.$ms.constant.Command.SaveView) {
        const {pushTrans: pushTransFunc} = collectionMonitor();
        pushTransFunc(proxy.$ms.constant.Command.CreateVoucherWithTaxDirect, `Lập chứng từ Nghiệp vụ khác theo phương pháp tính thuế trực tiếp`, 'GLVoucherDetail');
      } 
      proxy.super('pushTrans', baseDetailVoucher, command, isPrintVoucher, report);
    }

    return {
      pushTrans,
      titleCode,
      changeTriggers,
      changeTriggersTax,
      changeTriggersHT,
      backRouter: '/summary/glvoucher',
      layoutTagDetail,
      currentLayout,
      isCacheParam,
      layoutTagDetailOther,
      proxy,
      module,
      customColumns,
      getParallelModel,
      bindDefaultData,
      toggleAbove,
      toggleAboveHandler,
      selectedTab,
      selectedTabHandler,
      currencyColumns,
      comboboxDataRemote,
      bindData,
      onCurrencyComboboxLoadData,
      selectCurrency,
      onActionBlur,
      layoutTagDetailParallel,
      customDefaultData,
      propsData,
      buttonUtilities,
      buttonPrints,
      clickItemHandle,
      changeDataBusiness,
      columnsDataParalell,
      formatPrice,
      afterDeleteRow,
      totalAmountComputed,
      currencyCode,
      clickQuickAccounting,
      accountingActions,
      saveAsNewAutoBusiness,
      refType,
      defaultData,
      getDataDefault,
      toggleAboveHandlerGrid,
      getConfigLayout,
      assignValueCurrency,
      onBlurActionDatePicker,
      getSaveData,
      beforeBindData,
      beforeClose,
      cloneRow,
      getResultGrid,
      clickEdit,
      itemCLick,
      getLoadDataParameter,
      afterSubmitModeView,
      customVoucherLoadData,
      copyDownRow,
      copyDownRowExtend,
      copyActionClick,
      propsDataParalell,
      printVoucher,
      subSystemCode,
      steps,
      showRefNoInvoice,
      isViewInvoce,
      validateAccounting,
      dbOptionHeight,
      onPosted,
      customUnPostedSuccess,

      isShowVoucherReference,
      voucherReferenceItems,
      showFormVoucherReference,
      getRefTypeView,
      callbackChooseItem,
      setVoucherReferenceInfo,
      getGridDetail,
      initNewData,
      removeVoucherReference,
      saveError,
      showTargetLink,

      configAccountingGrid,
      configTaxGrid,
      configParallelGrid,
      disabledDelete,
      stepsDynamic,
      bindDataFromInbot,
      deleteSuccess,
      useTA,
      viewAccount,
      refNoBeforeUpdate,
      DBStartDateString: proxy.DBStartDateString,
      getParamDeleteDetail,
      getTaxKeyModel,
      getIgnoreFields,
      applyColumnByDbOptionCustom,
      isTaxReduction,
      validateRefDate,
      mappingCopyVoucher,
      taxDirectMethodValue,
      cloneVoucherDetail
    };
  },

  computed: {
    ...mapGetters({
      postedDate: ModuleContext + '/PostedDate',
    }),
    offlineReady() {
      if (!this.$store.state[ModuleOfflineWork]) return false;
      return this.$store.state[ModuleOfflineWork].offlineReady;
    },
  },
};
</script>
<style lang="scss">
.gl-general-voucher-detail {
  @import '@/views/sell/cAReceiptSale/CAReceiptSaleDetail.scss';
  .popup-container {
    overflow: unset !important;
  }
  .under-container {
    padding: 0 0 !important;
  }
  .btn {
    &.icon-button {
      background: none !important;
    }
  }
  .text-area-height1 {
    .ms-textarea-item {
      height: 78px !important;
      font-size: 12px;
      @include for_breakpoint(desktop-xl) {
        height: 82px !important;
      }
    }
    &.seperator-line {
      height: 89% !important;
    }
  }
  .text-area-height2 {
    .ms-textarea-item {
      height: 90px !important;
      @include for_breakpoint(desktop-xl) {
        height: 94px !important;
      }
    }
    &.seperator-line {
      height: 95% !important;
    }
  }
  .above-container {
    padding: 8px 16px 7px 22px !important;
  }

  .cb-currency {
    width: 110px !important;
  }

  .under-container {
    display: flex;
    flex-direction: column;
    padding-bottom: 0px !important;
  }

  .fast-edit {
    font-weight: 500;
    &:focus {
      color: $ms-label-function-color;
      border: 1px solid #bbb !important;
      :deep(.edit) {
        &:before {
          background-position: -239px -168px;
        }
      }
      :deep(.down-arrow-black) {
        &:before {
          background-position: -120px -72px;
        }
      }
    }
  }

  .grids-tab {
    display: flex;
    flex-direction: column;

    @include for_breakpoint(desktop-xl) {
      flex: 1;
      overflow: hidden;
    }

    .grid-container {
      height: calc(100% - 48px);
      overflow: auto;
    }
  }

  .tab-container {
    background-color: $ms-grey;
    padding: 5px 16px 0px 22px;
    position: relative;
  }
  .journal-memo {
    margin-top: 10px;
  }
  .header-right {
    justify-content: flex-end;
  }
  .control-title {
    width: 74px !important;
    margin-right: 16px;
    align-items: unset !important;
    padding-top: 6px;
  }
  .control-title-right {
    width: 53px !important;
    margin-right: 16px;
  }
  .grid-container {
    td {
      .ms-checkbox {
        display: inherit !important;
      }
    }
  }
  .modal__footer {
    background-color: $color-bg-popup;
    button {
      &.disabled-icon {
        opacity: 0.7;
      }
    }
  }
  .btn-opacity {
    color: $white !important;
    background-color: unset !important;
    border: unset !important;
  }
  .btn-footer-helpful {
    &:disabled {
      opacity: 0.5;
      cursor: unset;
      &:hover {
        background-color: transparent !important;
      }
    }
  }
  .w100px {
    width: 100px;
  }
  .update-btn {
    .text {
      color: $ms-label-function-color;
      padding: 0;
    }
    &.disabled-icon {
      .text {
        color: $secondary;
      }
    }
  }
  .voucher-reference {
    align-items: center;
    .ref-no {
      position: relative;
      margin-right: 16px;

      .text-link {
        color: #026aba;
        font-weight: 600;
      }

      .icon24 {
        height: 20px;
        position: absolute;
        top: -12px;
        right: -17px;
      }
    }

    .icon24 {
      height: 20px;
    }
  }
}
</style>
